var items = {
  "block.minecraft.acacia_button": "Сәрви төймә",
  "block.minecraft.acacia_door": "Сәрви ишек",
  "block.minecraft.acacia_fence": "Сәрви койма",
  "block.minecraft.acacia_fence_gate": "Сәрви капка",
  "block.minecraft.acacia_hanging_sign": "Элүле сәрви билге",
  "block.minecraft.acacia_leaves": "Сәрви яфраклары",
  "block.minecraft.acacia_log": "Сәрви бүрәнә",
  "block.minecraft.acacia_planks": "Сәрви такталар",
  "block.minecraft.acacia_pressure_plate": "Сәрви басма плитә",
  "block.minecraft.acacia_sapling": "Сәрви үсентесе",
  "block.minecraft.acacia_shelf": "Сәрви киштә",
  "block.minecraft.acacia_sign": "Сәрви билге",
  "block.minecraft.acacia_slab": "Сәрви плитә",
  "block.minecraft.acacia_stairs": "Сәрви баскычлар",
  "block.minecraft.acacia_trapdoor": "Сәрви люк",
  "block.minecraft.acacia_wall_hanging_sign": "Элүле сәрви дивардагы билге",
  "block.minecraft.acacia_wall_sign": "Сәрви дивардагы билге",
  "block.minecraft.acacia_wood": "Сәрви",
  "block.minecraft.activator_rail": "Активлаштыркыч тимер юл",
  "block.minecraft.air": "Һава",
  "block.minecraft.allium": "Сарымсак",
  "block.minecraft.amethyst_block": "Аметист блок",
  "block.minecraft.amethyst_cluster": "Аметист тупламасы",
  "block.minecraft.ancient_debris": "Борынгы җимерекләр",
  "block.minecraft.andesite": "Андезит",
  "block.minecraft.andesite_slab": "Андезит плитә",
  "block.minecraft.andesite_stairs": "Андезит баскычлар",
  "block.minecraft.andesite_wall": "Андезит киртә",
  "block.minecraft.anvil": "Сандал",
  "block.minecraft.attached_melon_stem": "Беркетелгән карбыз сабагы",
  "block.minecraft.attached_pumpkin_stem": "Беркетелгән кабак сабагы",
  "block.minecraft.azalea": "Азалия",
  "block.minecraft.azalea_leaves": "Азалия яфраклары",
  "block.minecraft.azure_bluet": "Зәңгәрсу күкбаш",
  "block.minecraft.bamboo": "Бамбук",
  "block.minecraft.bamboo_block": "Бамбук блок",
  "block.minecraft.bamboo_button": "Бамбук төймә",
  "block.minecraft.bamboo_door": "Бамбук ишек",
  "block.minecraft.bamboo_fence": "Бамбук койма",
  "block.minecraft.bamboo_fence_gate": "Бамбук капка",
  "block.minecraft.bamboo_hanging_sign": "Элүле бамбук билге",
  "block.minecraft.bamboo_mosaic": "Бамбук мозаика",
  "block.minecraft.bamboo_mosaic_slab": "Бамбук мозаика плитәсе",
  "block.minecraft.bamboo_mosaic_stairs": "Бамбук мозаика баскычлар",
  "block.minecraft.bamboo_planks": "Бамбук такталар",
  "block.minecraft.bamboo_pressure_plate": "Бамбук басма плитә",
  "block.minecraft.bamboo_sapling": "Бамбук үсентесе",
  "block.minecraft.bamboo_shelf": "Бамбук киштә",
  "block.minecraft.bamboo_sign": "Бамбук билге",
  "block.minecraft.bamboo_slab": "Бамбук плитә",
  "block.minecraft.bamboo_stairs": "Бамбук баскычлар",
  "block.minecraft.bamboo_trapdoor": "Бамбук люк",
  "block.minecraft.bamboo_wall_hanging_sign": "Элүле бамбук дивардагы билге",
  "block.minecraft.bamboo_wall_sign": "Бамбук дивардагы билге",
  "block.minecraft.banner.base.black": "Кара кыр",
  "block.minecraft.banner.base.blue": "Зәңгәр кыр",
  "block.minecraft.banner.base.brown": "Көрән кыр",
  "block.minecraft.banner.base.cyan": "Фирәзә кыр",
  "block.minecraft.banner.base.gray": "Соры кыр",
  "block.minecraft.banner.base.green": "Яшел кыр",
  "block.minecraft.banner.base.light_blue": "Зәңгәрсу кыр",
  "block.minecraft.banner.base.light_gray": "Соргылт кыр",
  "block.minecraft.banner.base.lime": "Яшькелт кыр",
  "block.minecraft.banner.base.magenta": "Куе кызыл кыр",
  "block.minecraft.banner.base.orange": "Кызгылт сары кыр",
  "block.minecraft.banner.base.pink": "Ал кыр",
  "block.minecraft.banner.base.purple": "Шәмәхә кыр",
  "block.minecraft.banner.base.red": "Кызыл кыр",
  "block.minecraft.banner.base.white": "Ак кыр",
  "block.minecraft.banner.base.yellow": "Сары кыр",
  "block.minecraft.banner.border.black": "Кара кайма",
  "block.minecraft.banner.border.blue": "Зәңгәр кайма",
  "block.minecraft.banner.border.brown": "Көрән кайма",
  "block.minecraft.banner.border.cyan": "Фирәзә кайма",
  "block.minecraft.banner.border.gray": "Соры кайма",
  "block.minecraft.banner.border.green": "Яшел кайма",
  "block.minecraft.banner.border.light_blue": "Зәңгәрсу кайма",
  "block.minecraft.banner.border.light_gray": "Соргылт кайма",
  "block.minecraft.banner.border.lime": "Яшькелт кайма",
  "block.minecraft.banner.border.magenta": "Куе кызыл кайма",
  "block.minecraft.banner.border.orange": "Кызгылт сары кайма",
  "block.minecraft.banner.border.pink": "Ал кайма",
  "block.minecraft.banner.border.purple": "Шәмәхә кайма",
  "block.minecraft.banner.border.red": "Кызыл кайма",
  "block.minecraft.banner.border.white": "Ак кайма",
  "block.minecraft.banner.border.yellow": "Сары кайма",
  "block.minecraft.banner.bricks.black": "Кара кирпеч томалау",
  "block.minecraft.banner.bricks.blue": "Зәңгәр кирпеч томалау",
  "block.minecraft.banner.bricks.brown": "Көрән кирпеч томалау",
  "block.minecraft.banner.bricks.cyan": "Фирәзә кирпеч томалау",
  "block.minecraft.banner.bricks.gray": "Соры кирпеч томалау",
  "block.minecraft.banner.bricks.green": "Яшел кирпеч томалау",
  "block.minecraft.banner.bricks.light_blue": "Зәңгәрсу кирпеч томалау",
  "block.minecraft.banner.bricks.light_gray": "Соргылт кирпеч томалау",
  "block.minecraft.banner.bricks.lime": "Яшькелт кирпеч томалау",
  "block.minecraft.banner.bricks.magenta": "Куе кызыл кирпеч томалау",
  "block.minecraft.banner.bricks.orange": "Кызгылт сары кирпеч томалау",
  "block.minecraft.banner.bricks.pink": "Ал кирпеч томалау",
  "block.minecraft.banner.bricks.purple": "Шәмәхә кирпеч томалау",
  "block.minecraft.banner.bricks.red": "Кызыл кирпеч томалау",
  "block.minecraft.banner.bricks.white": "Ак кирпеч томалау",
  "block.minecraft.banner.bricks.yellow": "Сары кирпеч томалау",
  "block.minecraft.banner.circle.black": "Кара түгәрәк",
  "block.minecraft.banner.circle.blue": "Зәңгәр түгәрәк",
  "block.minecraft.banner.circle.brown": "Көрән түгәрәк",
  "block.minecraft.banner.circle.cyan": "Фирәзә түгәрәк",
  "block.minecraft.banner.circle.gray": "Соры түгәрәк",
  "block.minecraft.banner.circle.green": "Яшел түгәрәк",
  "block.minecraft.banner.circle.light_blue": "Зәңгәрсу түгәрәк",
  "block.minecraft.banner.circle.light_gray": "Соргылт түгәрәк",
  "block.minecraft.banner.circle.lime": "Яшькелт түгәрәк",
  "block.minecraft.banner.circle.magenta": "Куе кызыл түгәрәк",
  "block.minecraft.banner.circle.orange": "Кызгылт сары түгәрәк",
  "block.minecraft.banner.circle.pink": "Ал түгәрәк",
  "block.minecraft.banner.circle.purple": "Шәмәхә түгәрәк",
  "block.minecraft.banner.circle.red": "Кызыл түгәрәк",
  "block.minecraft.banner.circle.white": "Ак түгәрәк",
  "block.minecraft.banner.circle.yellow": "Сары түгәрәк",
  "block.minecraft.banner.creeper.black": "Кара крипер",
  "block.minecraft.banner.creeper.blue": "Зәңгәр крипер",
  "block.minecraft.banner.creeper.brown": "Көрән крипер",
  "block.minecraft.banner.creeper.cyan": "Фирәзә крипер",
  "block.minecraft.banner.creeper.gray": "Соры крипер",
  "block.minecraft.banner.creeper.green": "Яшел крипер",
  "block.minecraft.banner.creeper.light_blue": "Зәңгәрсу крипер",
  "block.minecraft.banner.creeper.light_gray": "Соргылт крипер",
  "block.minecraft.banner.creeper.lime": "Яшькелт крипер",
  "block.minecraft.banner.creeper.magenta": "Куе кызыл крипер",
  "block.minecraft.banner.creeper.orange": "Кызгылт сары крипер",
  "block.minecraft.banner.creeper.pink": "Ал крипер",
  "block.minecraft.banner.creeper.purple": "Шәмәхә крипер",
  "block.minecraft.banner.creeper.red": "Кызыл крипер",
  "block.minecraft.banner.creeper.white": "Ак крипер",
  "block.minecraft.banner.creeper.yellow": "Сары крипер",
  "block.minecraft.banner.cross.black": "Кара Андрей тәресе",
  "block.minecraft.banner.cross.blue": "Зәңгәр Андрей тәресе",
  "block.minecraft.banner.cross.brown": "Көрән Андрей тәресе",
  "block.minecraft.banner.cross.cyan": "Фирәзә Андрей тәресе",
  "block.minecraft.banner.cross.gray": "Соры Андрей тәресе",
  "block.minecraft.banner.cross.green": "Яшел Андрей тәресе",
  "block.minecraft.banner.cross.light_blue": "Зәңгәрсу Андрей тәресе",
  "block.minecraft.banner.cross.light_gray": "Соргылт Андрей тәресе",
  "block.minecraft.banner.cross.lime": "Яшькелт Андрей тәресе",
  "block.minecraft.banner.cross.magenta": "Куе кызыл Андрей тәресе",
  "block.minecraft.banner.cross.orange": "Кызгылт сары Андрей тәресе",
  "block.minecraft.banner.cross.pink": "Ал Андрей тәресе",
  "block.minecraft.banner.cross.purple": "Шәмәхә Андрей тәресе",
  "block.minecraft.banner.cross.red": "Кызыл Андрей тәресе",
  "block.minecraft.banner.cross.white": "Ак Андрей тәресе",
  "block.minecraft.banner.cross.yellow": "Сары Андрей тәресе",
  "block.minecraft.banner.curly_border.black": "Кара бизәкле кайма",
  "block.minecraft.banner.curly_border.blue": "Зәңгәр бизәкле кайма",
  "block.minecraft.banner.curly_border.brown": "Көрән бизәкле кайма",
  "block.minecraft.banner.curly_border.cyan": "Фирәзә бизәкле кайма",
  "block.minecraft.banner.curly_border.gray": "Соры бизәкле кайма",
  "block.minecraft.banner.curly_border.green": "Яшел бизәкле кайма",
  "block.minecraft.banner.curly_border.light_blue": "Зәңгәрсу бизәкле кайма",
  "block.minecraft.banner.curly_border.light_gray": "Соргылт бизәкле кайма",
  "block.minecraft.banner.curly_border.lime": "Яшькелт бизәкле кайма",
  "block.minecraft.banner.curly_border.magenta": "Куе кызыл бизәкле кайма",
  "block.minecraft.banner.curly_border.orange": "Кызгылт сары бизәкле кайма",
  "block.minecraft.banner.curly_border.pink": "Ал бизәкле кайма",
  "block.minecraft.banner.curly_border.purple": "Шәмәхә бизәкле кайма",
  "block.minecraft.banner.curly_border.red": "Кызыл бизәкле кайма",
  "block.minecraft.banner.curly_border.white": "Ак бизәкле кайма",
  "block.minecraft.banner.curly_border.yellow": "Сары бизәкле кайма",
  "block.minecraft.banner.diagonal_left.black": "Кара сул киселеш",
  "block.minecraft.banner.diagonal_left.blue": "Зәңгәр сул киселеш",
  "block.minecraft.banner.diagonal_left.brown": "Көрән сул киселеш",
  "block.minecraft.banner.diagonal_left.cyan": "Фирәзә сул киселеш",
  "block.minecraft.banner.diagonal_left.gray": "Соры сул киселеш",
  "block.minecraft.banner.diagonal_left.green": "Яшел сул киселеш",
  "block.minecraft.banner.diagonal_left.light_blue": "Зәңгәрсу сул киселеш",
  "block.minecraft.banner.diagonal_left.light_gray": "Соргылт сул киселеш",
  "block.minecraft.banner.diagonal_left.lime": "Яшькелт сул киселеш",
  "block.minecraft.banner.diagonal_left.magenta": "Куе кызыл сул киселеш",
  "block.minecraft.banner.diagonal_left.orange": "Кызгылт сары сул киселеш",
  "block.minecraft.banner.diagonal_left.pink": "Ал сул киселеш",
  "block.minecraft.banner.diagonal_left.purple": "Шәмәхә сул киселеш",
  "block.minecraft.banner.diagonal_left.red": "Кызыл сул киселеш",
  "block.minecraft.banner.diagonal_left.white": "Ак сул киселеш",
  "block.minecraft.banner.diagonal_left.yellow": "Сары сул киселеш",
  "block.minecraft.banner.diagonal_right.black": "Кара киселеш",
  "block.minecraft.banner.diagonal_right.blue": "Зәңгәр киселеш",
  "block.minecraft.banner.diagonal_right.brown": "Көрән киселеш",
  "block.minecraft.banner.diagonal_right.cyan": "Фирәзә киселеш",
  "block.minecraft.banner.diagonal_right.gray": "Соры киселеш",
  "block.minecraft.banner.diagonal_right.green": "Яшел киселеш",
  "block.minecraft.banner.diagonal_right.light_blue": "Зәңгәрсу киселеш",
  "block.minecraft.banner.diagonal_right.light_gray": "Соргылт киселеш",
  "block.minecraft.banner.diagonal_right.lime": "Яшькелт киселеш",
  "block.minecraft.banner.diagonal_right.magenta": "Куе кызыл киселеш",
  "block.minecraft.banner.diagonal_right.orange": "Кызгылт сары киселеш",
  "block.minecraft.banner.diagonal_right.pink": "Ал киселеш",
  "block.minecraft.banner.diagonal_right.purple": "Шәмәхә киселеш",
  "block.minecraft.banner.diagonal_right.red": "Кызыл киселеш",
  "block.minecraft.banner.diagonal_right.white": "Ак киселеш",
  "block.minecraft.banner.diagonal_right.yellow": "Сары киселеш",
  "block.minecraft.banner.diagonal_up_left.black": "Кара аударылган киселеш",
  "block.minecraft.banner.diagonal_up_left.blue": "Зәңгәр аударылган киселеш",
  "block.minecraft.banner.diagonal_up_left.brown": "Көрән аударылган киселеш",
  "block.minecraft.banner.diagonal_up_left.cyan": "Фирәзә аударылган киселеш",
  "block.minecraft.banner.diagonal_up_left.gray": "Соры аударылган киселеш",
  "block.minecraft.banner.diagonal_up_left.green": "Яшел аударылган киселеш",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Зәңгәрсу аударылган киселеш",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Соргылт аударылган киселеш",
  "block.minecraft.banner.diagonal_up_left.lime": "Яшькелт аударылган киселеш",
  "block.minecraft.banner.diagonal_up_left.magenta": "Куе кызыл аударылган киселеш",
  "block.minecraft.banner.diagonal_up_left.orange": "Кызгылт сары аударылган киселеш",
  "block.minecraft.banner.diagonal_up_left.pink": "Ал аударылган киселеш",
  "block.minecraft.banner.diagonal_up_left.purple": "Шәмәхә аударылган киселеш",
  "block.minecraft.banner.diagonal_up_left.red": "Кызыл аударылган киселеш",
  "block.minecraft.banner.diagonal_up_left.white": "Ак аударылган киселеш",
  "block.minecraft.banner.diagonal_up_left.yellow": "Сары аударылган киселеш",
  "block.minecraft.banner.diagonal_up_right.black": "Кара уңга аударылган киселеш",
  "block.minecraft.banner.diagonal_up_right.blue": "Зәңгәр уңга аударылган киселеш",
  "block.minecraft.banner.diagonal_up_right.brown": "Көрән уңга аударылган киселеш",
  "block.minecraft.banner.diagonal_up_right.cyan": "Фирәзә уңга аударылган киселеш",
  "block.minecraft.banner.diagonal_up_right.gray": "Соры уңга аударылган киселеш",
  "block.minecraft.banner.diagonal_up_right.green": "Яшел уңга аударылган киселеш",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Зәңгәрсу уңга аударылган киселеш",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Соргылт уңга аударылган киселеш",
  "block.minecraft.banner.diagonal_up_right.lime": "Яшькелт уңга аударылган киселеш",
  "block.minecraft.banner.diagonal_up_right.magenta": "Куе кызыл уңга аударылган киселеш",
  "block.minecraft.banner.diagonal_up_right.orange": "Кызгылт сары уңга аударылган киселеш",
  "block.minecraft.banner.diagonal_up_right.pink": "Ал уңга аударылган киселеш",
  "block.minecraft.banner.diagonal_up_right.purple": "Шәмәхә уңга аударылган киселеш",
  "block.minecraft.banner.diagonal_up_right.red": "Кызыл уңга аударылган киселеш",
  "block.minecraft.banner.diagonal_up_right.white": "Ак уңга аударылган киселеш",
  "block.minecraft.banner.diagonal_up_right.yellow": "Сары уңга аударылган киселеш",
  "block.minecraft.banner.flow.black": "Кара агым",
  "block.minecraft.banner.flow.blue": "Зәңгәр агым",
  "block.minecraft.banner.flow.brown": "Көрән агым",
  "block.minecraft.banner.flow.cyan": "Фирәзә агым",
  "block.minecraft.banner.flow.gray": "Соры агым",
  "block.minecraft.banner.flow.green": "Яшел агым",
  "block.minecraft.banner.flow.light_blue": "Зәңгәрсу агым",
  "block.minecraft.banner.flow.light_gray": "Соргылт агым",
  "block.minecraft.banner.flow.lime": "Яшькелт агым",
  "block.minecraft.banner.flow.magenta": "Куе кызыл агым",
  "block.minecraft.banner.flow.orange": "Кызгылт сары агым",
  "block.minecraft.banner.flow.pink": "Ал агым",
  "block.minecraft.banner.flow.purple": "Шәмәхә агым",
  "block.minecraft.banner.flow.red": "Кызыл агым",
  "block.minecraft.banner.flow.white": "Ак агым",
  "block.minecraft.banner.flow.yellow": "Сары агым",
  "block.minecraft.banner.flower.black": "Кара чәчәк",
  "block.minecraft.banner.flower.blue": "Зәңгәр чәчәк",
  "block.minecraft.banner.flower.brown": "Көрән чәчәк",
  "block.minecraft.banner.flower.cyan": "Фирәзә чәчәк",
  "block.minecraft.banner.flower.gray": "Соры чәчәк",
  "block.minecraft.banner.flower.green": "Яшел чәчәк",
  "block.minecraft.banner.flower.light_blue": "Зәңгәрсу чәчәк",
  "block.minecraft.banner.flower.light_gray": "Соргылт чәчәк",
  "block.minecraft.banner.flower.lime": "Яшькелт чәчәк",
  "block.minecraft.banner.flower.magenta": "Куе кызыл чәчәк",
  "block.minecraft.banner.flower.orange": "Кызгылт сары чәчәк",
  "block.minecraft.banner.flower.pink": "Ал чәчәк",
  "block.minecraft.banner.flower.purple": "Шәмәхә чәчәк",
  "block.minecraft.banner.flower.red": "Кызыл чәчәк",
  "block.minecraft.banner.flower.white": "Ак чәчәк",
  "block.minecraft.banner.flower.yellow": "Сары чәчәк",
  "block.minecraft.banner.globe.black": "Кара глобус",
  "block.minecraft.banner.globe.blue": "Зәңгәр глобус",
  "block.minecraft.banner.globe.brown": "Көрән глобус",
  "block.minecraft.banner.globe.cyan": "Фирәзә глобус",
  "block.minecraft.banner.globe.gray": "Соры глобус",
  "block.minecraft.banner.globe.green": "Яшел глобус",
  "block.minecraft.banner.globe.light_blue": "Зәңгәрсу глобус",
  "block.minecraft.banner.globe.light_gray": "Соргылт глобус",
  "block.minecraft.banner.globe.lime": "Яшькелт глобус",
  "block.minecraft.banner.globe.magenta": "Куе кызыл глобус",
  "block.minecraft.banner.globe.orange": "Кызгылт сары глобус",
  "block.minecraft.banner.globe.pink": "Ал глобус",
  "block.minecraft.banner.globe.purple": "Шәмәхә глобус",
  "block.minecraft.banner.globe.red": "Кызыл глобус",
  "block.minecraft.banner.globe.white": "Ак глобус",
  "block.minecraft.banner.globe.yellow": "Сары глобус",
  "block.minecraft.banner.gradient.black": "Кара градиент",
  "block.minecraft.banner.gradient.blue": "Зәңгәр градиент",
  "block.minecraft.banner.gradient.brown": "Көрән градиент",
  "block.minecraft.banner.gradient.cyan": "Фирәзә градиент",
  "block.minecraft.banner.gradient.gray": "Соры градиент",
  "block.minecraft.banner.gradient.green": "Яшел градиент",
  "block.minecraft.banner.gradient.light_blue": "Зәңгәрсу градиент",
  "block.minecraft.banner.gradient.light_gray": "Соргылт градиент",
  "block.minecraft.banner.gradient.lime": "Яшькелт градиент",
  "block.minecraft.banner.gradient.magenta": "Куе кызыл градиент",
  "block.minecraft.banner.gradient.orange": "Кызгылт сары градиент",
  "block.minecraft.banner.gradient.pink": "Ал градиент",
  "block.minecraft.banner.gradient.purple": "Шәмәхә градиент",
  "block.minecraft.banner.gradient.red": "Кызыл градиент",
  "block.minecraft.banner.gradient.white": "Ак градиент",
  "block.minecraft.banner.gradient.yellow": "Сары градиент",
  "block.minecraft.banner.gradient_up.black": "Кара кире градиент",
  "block.minecraft.banner.gradient_up.blue": "Зәңгәр кире градиент",
  "block.minecraft.banner.gradient_up.brown": "Көрән кире градиент",
  "block.minecraft.banner.gradient_up.cyan": "Фирәзә кире градиент",
  "block.minecraft.banner.gradient_up.gray": "Соры кире градиент",
  "block.minecraft.banner.gradient_up.green": "Яшел кире градиент",
  "block.minecraft.banner.gradient_up.light_blue": "Зәңгәрсу кире градиент",
  "block.minecraft.banner.gradient_up.light_gray": "Соргылт кире градиент",
  "block.minecraft.banner.gradient_up.lime": "Яшькелт кире градиент",
  "block.minecraft.banner.gradient_up.magenta": "Куе кызыл кире градиент",
  "block.minecraft.banner.gradient_up.orange": "Кызгылт сары кире градиент",
  "block.minecraft.banner.gradient_up.pink": "Ал кире градиент",
  "block.minecraft.banner.gradient_up.purple": "Шәмәхә кире градиент",
  "block.minecraft.banner.gradient_up.red": "Кызыл кире градиент",
  "block.minecraft.banner.gradient_up.white": "Ак кире градиент",
  "block.minecraft.banner.gradient_up.yellow": "Сары кире градиент",
  "block.minecraft.banner.guster.black": "Кара өермә",
  "block.minecraft.banner.guster.blue": "Зәңгәр өермә",
  "block.minecraft.banner.guster.brown": "Көрән өермә",
  "block.minecraft.banner.guster.cyan": "Фирәзә өермә",
  "block.minecraft.banner.guster.gray": "Соры өермә",
  "block.minecraft.banner.guster.green": "Яшел өермә",
  "block.minecraft.banner.guster.light_blue": "Зәңгәрсу өермә",
  "block.minecraft.banner.guster.light_gray": "Соргылт өермә",
  "block.minecraft.banner.guster.lime": "Яшькелт өермә",
  "block.minecraft.banner.guster.magenta": "Куе кызыл өермә",
  "block.minecraft.banner.guster.orange": "Кызгылт сары өермә",
  "block.minecraft.banner.guster.pink": "Ал өермә",
  "block.minecraft.banner.guster.purple": "Шәмәхә өермә",
  "block.minecraft.banner.guster.red": "Кызыл өермә",
  "block.minecraft.banner.guster.white": "Ак өермә",
  "block.minecraft.banner.guster.yellow": "Сары өермә",
  "block.minecraft.banner.half_horizontal.black": "Кара өс як",
  "block.minecraft.banner.half_horizontal.blue": "Зәңгәр өс як",
  "block.minecraft.banner.half_horizontal.brown": "Көрән өс як",
  "block.minecraft.banner.half_horizontal.cyan": "Фирәзә өс як",
  "block.minecraft.banner.half_horizontal.gray": "Соры өс як",
  "block.minecraft.banner.half_horizontal.green": "Яшел өс як",
  "block.minecraft.banner.half_horizontal.light_blue": "Зәңгәрсу өс як",
  "block.minecraft.banner.half_horizontal.light_gray": "Соргылт өс як",
  "block.minecraft.banner.half_horizontal.lime": "Яшькелт өс як",
  "block.minecraft.banner.half_horizontal.magenta": "Куе кызыл өс як",
  "block.minecraft.banner.half_horizontal.orange": "Кызгылт сары өс як",
  "block.minecraft.banner.half_horizontal.pink": "Ал өс як",
  "block.minecraft.banner.half_horizontal.purple": "Шәмәхә өс як",
  "block.minecraft.banner.half_horizontal.red": "Кызыл өс як",
  "block.minecraft.banner.half_horizontal.white": "Ак өс як",
  "block.minecraft.banner.half_horizontal.yellow": "Сары өс як",
  "block.minecraft.banner.half_horizontal_bottom.black": "Кара ас як",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Зәңгәр ас як",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Көрән ас як",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Фирәзә ас як",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Соры ас як",
  "block.minecraft.banner.half_horizontal_bottom.green": "Яшел ас як",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Зәңгәрсу ас як",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Соргылт ас як",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Яшькелт ас як",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Куе кызыл ас як",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Кызгылт сары аскы як",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Ал ас як",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Шәмәхә ас як",
  "block.minecraft.banner.half_horizontal_bottom.red": "Кызыл ас як",
  "block.minecraft.banner.half_horizontal_bottom.white": "Ак ас як",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Сары ас як",
  "block.minecraft.banner.half_vertical.black": "Кара сул як",
  "block.minecraft.banner.half_vertical.blue": "Зәңгәр сул як",
  "block.minecraft.banner.half_vertical.brown": "Көрән сул як",
  "block.minecraft.banner.half_vertical.cyan": "Фирәзә сул як",
  "block.minecraft.banner.half_vertical.gray": "Соры сул як",
  "block.minecraft.banner.half_vertical.green": "Яшел сул як",
  "block.minecraft.banner.half_vertical.light_blue": "Зәңгәрсу сул як",
  "block.minecraft.banner.half_vertical.light_gray": "Соргылт сул як",
  "block.minecraft.banner.half_vertical.lime": "Яшькелт сул як",
  "block.minecraft.banner.half_vertical.magenta": "Куе кызыл сул як",
  "block.minecraft.banner.half_vertical.orange": "Кызгылт сары сул як",
  "block.minecraft.banner.half_vertical.pink": "Ал сул як",
  "block.minecraft.banner.half_vertical.purple": "Шәмәхә сул як",
  "block.minecraft.banner.half_vertical.red": "Кызыл сул як",
  "block.minecraft.banner.half_vertical.white": "Ак сул як",
  "block.minecraft.banner.half_vertical.yellow": "Сары сул як",
  "block.minecraft.banner.half_vertical_right.black": "Кара уң як",
  "block.minecraft.banner.half_vertical_right.blue": "Зәңгәрле уң як",
  "block.minecraft.banner.half_vertical_right.brown": "Көрән уң як",
  "block.minecraft.banner.half_vertical_right.cyan": "Фирәзә уң як",
  "block.minecraft.banner.half_vertical_right.gray": "Соры уң як",
  "block.minecraft.banner.half_vertical_right.green": "Яшел уң як",
  "block.minecraft.banner.half_vertical_right.light_blue": "Зәңгәрсу уң як",
  "block.minecraft.banner.half_vertical_right.light_gray": "Соргылт уң як",
  "block.minecraft.banner.half_vertical_right.lime": "Яшькелт уң як",
  "block.minecraft.banner.half_vertical_right.magenta": "Куе кызыл уң як",
  "block.minecraft.banner.half_vertical_right.orange": "Кызгылт сары уң як",
  "block.minecraft.banner.half_vertical_right.pink": "Ал уң як",
  "block.minecraft.banner.half_vertical_right.purple": "Шәмәхә уң як",
  "block.minecraft.banner.half_vertical_right.red": "Кызыл уң як",
  "block.minecraft.banner.half_vertical_right.white": "Ак уң як",
  "block.minecraft.banner.half_vertical_right.yellow": "Сары уң як",
  "block.minecraft.banner.mojang.black": "Кара нәрсәдер",
  "block.minecraft.banner.mojang.blue": "Зәңгәр нәрсәдер",
  "block.minecraft.banner.mojang.brown": "Көрән нәрсәдер",
  "block.minecraft.banner.mojang.cyan": "Фирәзә нәрсәдер",
  "block.minecraft.banner.mojang.gray": "Соры нәрсәдер",
  "block.minecraft.banner.mojang.green": "Яшел нәрсәдер",
  "block.minecraft.banner.mojang.light_blue": "Зәңгәрсу нәрсәдер",
  "block.minecraft.banner.mojang.light_gray": "Соргылт нәрсәдер",
  "block.minecraft.banner.mojang.lime": "Яшькелт нәрсәдер",
  "block.minecraft.banner.mojang.magenta": "Куе кызыл нәрсәдер",
  "block.minecraft.banner.mojang.orange": "Кызгылт сары нәрсәдер",
  "block.minecraft.banner.mojang.pink": "Ал нәрсәдер",
  "block.minecraft.banner.mojang.purple": "Шәмәхә нәрсәдер",
  "block.minecraft.banner.mojang.red": "Кызыл нәрсәдер",
  "block.minecraft.banner.mojang.white": "Ак нәрсәдер",
  "block.minecraft.banner.mojang.yellow": "Сары нәрсәдер",
  "block.minecraft.banner.piglin.black": "Кара чырай",
  "block.minecraft.banner.piglin.blue": "Зәңгәр чырай",
  "block.minecraft.banner.piglin.brown": "Көрән чырай",
  "block.minecraft.banner.piglin.cyan": "Фирәзә чырай",
  "block.minecraft.banner.piglin.gray": "Соры чырай",
  "block.minecraft.banner.piglin.green": "Яшел чырай",
  "block.minecraft.banner.piglin.light_blue": "Зәңгәрсу чырай",
  "block.minecraft.banner.piglin.light_gray": "Соргылт чырай",
  "block.minecraft.banner.piglin.lime": "Яшькелт чырай",
  "block.minecraft.banner.piglin.magenta": "Куе кызыл чырай",
  "block.minecraft.banner.piglin.orange": "Кызгылт соры чырай",
  "block.minecraft.banner.piglin.pink": "Ал чырай",
  "block.minecraft.banner.piglin.purple": "Шәмәхә чырай",
  "block.minecraft.banner.piglin.red": "Кызыл чырай",
  "block.minecraft.banner.piglin.white": "Ак чырай",
  "block.minecraft.banner.piglin.yellow": "Соры чырай",
  "block.minecraft.banner.rhombus.black": "Кара ромб",
  "block.minecraft.banner.rhombus.blue": "Зәңгәр ромб",
  "block.minecraft.banner.rhombus.brown": "Көрән ромб",
  "block.minecraft.banner.rhombus.cyan": "Фирәзә ромб",
  "block.minecraft.banner.rhombus.gray": "Соры ромб",
  "block.minecraft.banner.rhombus.green": "Яшел ромб",
  "block.minecraft.banner.rhombus.light_blue": "Зәңгәрсу ромб",
  "block.minecraft.banner.rhombus.light_gray": "Соргылт ромб",
  "block.minecraft.banner.rhombus.lime": "Яшькелт ромб",
  "block.minecraft.banner.rhombus.magenta": "Куе кызыл ромб",
  "block.minecraft.banner.rhombus.orange": "Кызгылт сары ромб",
  "block.minecraft.banner.rhombus.pink": "Ал ромб",
  "block.minecraft.banner.rhombus.purple": "Шәмәхә ромб",
  "block.minecraft.banner.rhombus.red": "Кызыл ромб",
  "block.minecraft.banner.rhombus.white": "Ак ромб",
  "block.minecraft.banner.rhombus.yellow": "Сары ромб",
  "block.minecraft.banner.skull.black": "Кара баш сөяге",
  "block.minecraft.banner.skull.blue": "Зәңгәрле баш сөяге",
  "block.minecraft.banner.skull.brown": "Көрәнле баш сөяге",
  "block.minecraft.banner.skull.cyan": "Фирәзә баш сөяге",
  "block.minecraft.banner.skull.gray": "Соры баш сөяге",
  "block.minecraft.banner.skull.green": "Яшел баш сөяге",
  "block.minecraft.banner.skull.light_blue": "Зәңгәрсу баш сөяге",
  "block.minecraft.banner.skull.light_gray": "Соргылт баш сөяге",
  "block.minecraft.banner.skull.lime": "Яшькелт баш сөяге",
  "block.minecraft.banner.skull.magenta": "Куе кызыл баш сөяге",
  "block.minecraft.banner.skull.orange": "Кызгылт сары баш сөяге",
  "block.minecraft.banner.skull.pink": "Ал баш сөяге",
  "block.minecraft.banner.skull.purple": "Шәмәхә баш сөяге",
  "block.minecraft.banner.skull.red": "Кызыл баш сөяге",
  "block.minecraft.banner.skull.white": "Ак баш сөяге",
  "block.minecraft.banner.skull.yellow": "Сары баш сөяге",
  "block.minecraft.banner.small_stripes.black": "Кара баганалар",
  "block.minecraft.banner.small_stripes.blue": "Зәңгәр баганалар",
  "block.minecraft.banner.small_stripes.brown": "Көрән баганалар",
  "block.minecraft.banner.small_stripes.cyan": "Фирәзә баганалар",
  "block.minecraft.banner.small_stripes.gray": "Соры баганалар",
  "block.minecraft.banner.small_stripes.green": "Яшел баганалар",
  "block.minecraft.banner.small_stripes.light_blue": "Зәңгәрсу баганалар",
  "block.minecraft.banner.small_stripes.light_gray": "Соргылт баганалар",
  "block.minecraft.banner.small_stripes.lime": "Яшькелт баганалар",
  "block.minecraft.banner.small_stripes.magenta": "Куе кызыл баганалар",
  "block.minecraft.banner.small_stripes.orange": "Кызгылт сары баганалар",
  "block.minecraft.banner.small_stripes.pink": "Ал баганалар",
  "block.minecraft.banner.small_stripes.purple": "Шәмәхә баганалар",
  "block.minecraft.banner.small_stripes.red": "Кызыл баганалар",
  "block.minecraft.banner.small_stripes.white": "Ак баганалар",
  "block.minecraft.banner.small_stripes.yellow": "Сары баганалар",
  "block.minecraft.banner.square_bottom_left.black": "Кара аскы уң почмак",
  "block.minecraft.banner.square_bottom_left.blue": "Зәңгәр аскы уң почмак",
  "block.minecraft.banner.square_bottom_left.brown": "Көрән аскы уң почмак",
  "block.minecraft.banner.square_bottom_left.cyan": "Фирәзә аскы уң почмак",
  "block.minecraft.banner.square_bottom_left.gray": "Соры аскы уң почмак",
  "block.minecraft.banner.square_bottom_left.green": "Яшел аскы уң почмак",
  "block.minecraft.banner.square_bottom_left.light_blue": "Зәңгәрсу аскы уң почмак",
  "block.minecraft.banner.square_bottom_left.light_gray": "Соргылт аскы уң почмак",
  "block.minecraft.banner.square_bottom_left.lime": "Яшькелт аскы уң почмак",
  "block.minecraft.banner.square_bottom_left.magenta": "Куе кызыл аскы уң почмак",
  "block.minecraft.banner.square_bottom_left.orange": "Кызгылт сары аскы уң почмак",
  "block.minecraft.banner.square_bottom_left.pink": "Ал аскы уң почмак",
  "block.minecraft.banner.square_bottom_left.purple": "Шәмәхә аскы уң почмак",
  "block.minecraft.banner.square_bottom_left.red": "Кызыл аскы уң почмак",
  "block.minecraft.banner.square_bottom_left.white": "Ак аскы уң почмак",
  "block.minecraft.banner.square_bottom_left.yellow": "Сары аскы уң почмак",
  "block.minecraft.banner.square_bottom_right.black": "Кара аскы сул почмак",
  "block.minecraft.banner.square_bottom_right.blue": "Зәңгәр аскы сул почмак",
  "block.minecraft.banner.square_bottom_right.brown": "Көрән аскы сул почмак",
  "block.minecraft.banner.square_bottom_right.cyan": "Фирәзә аскы сул почмак",
  "block.minecraft.banner.square_bottom_right.gray": "Соры аскы сул почмак",
  "block.minecraft.banner.square_bottom_right.green": "Яшел аскы сул почмак",
  "block.minecraft.banner.square_bottom_right.light_blue": "Зәңгәрсу аскы сул почмак",
  "block.minecraft.banner.square_bottom_right.light_gray": "Соргылт аскы сул почмак",
  "block.minecraft.banner.square_bottom_right.lime": "Яшькелт аскы сул почмак",
  "block.minecraft.banner.square_bottom_right.magenta": "Куе кызыл аскы сул почмак",
  "block.minecraft.banner.square_bottom_right.orange": "Кызгылт сары аскы сул почмак",
  "block.minecraft.banner.square_bottom_right.pink": "Ал аскы сул почмак",
  "block.minecraft.banner.square_bottom_right.purple": "Шәмәхә аскы сул почмак",
  "block.minecraft.banner.square_bottom_right.red": "Кызыл аскы сул почмак",
  "block.minecraft.banner.square_bottom_right.white": "Ак аскы сул почмак",
  "block.minecraft.banner.square_bottom_right.yellow": "Сары аскы сул почмак",
  "block.minecraft.banner.square_top_left.black": "Кара өске уң почмак",
  "block.minecraft.banner.square_top_left.blue": "Зәңгәр өске уң почмак",
  "block.minecraft.banner.square_top_left.brown": "Көрән өске уң почмак",
  "block.minecraft.banner.square_top_left.cyan": "Фирәзә өске уң почмак",
  "block.minecraft.banner.square_top_left.gray": "Соры өске уң почмак",
  "block.minecraft.banner.square_top_left.green": "Яшел өске уң почмак",
  "block.minecraft.banner.square_top_left.light_blue": "Зәңгәрсу өске уң почмак",
  "block.minecraft.banner.square_top_left.light_gray": "Соргылт өске уң почмак",
  "block.minecraft.banner.square_top_left.lime": "Яшькелт өске уң почмак",
  "block.minecraft.banner.square_top_left.magenta": "Куе кызыл өске уң почмак",
  "block.minecraft.banner.square_top_left.orange": "Кызгылт сары өске уң почмак",
  "block.minecraft.banner.square_top_left.pink": "Ал өске уң почмак",
  "block.minecraft.banner.square_top_left.purple": "Шәмәхә өске уң почмак",
  "block.minecraft.banner.square_top_left.red": "Кызыл өске уң почмак",
  "block.minecraft.banner.square_top_left.white": "Ак өске уң почмак",
  "block.minecraft.banner.square_top_left.yellow": "Сары өске уң почмак",
  "block.minecraft.banner.square_top_right.black": "Кара өске сул почмак",
  "block.minecraft.banner.square_top_right.blue": "Зәңгәр өске сул почмак",
  "block.minecraft.banner.square_top_right.brown": "Көрән өске сул почмак",
  "block.minecraft.banner.square_top_right.cyan": "Фирәзә өске сул почмак",
  "block.minecraft.banner.square_top_right.gray": "Соры өске сул почмак",
  "block.minecraft.banner.square_top_right.green": "Яшел өске сул почмак",
  "block.minecraft.banner.square_top_right.light_blue": "Зәңгәрсу өске сул почмак",
  "block.minecraft.banner.square_top_right.light_gray": "Соргылт өске сул почмак",
  "block.minecraft.banner.square_top_right.lime": "Яшькелт өске сул почмак",
  "block.minecraft.banner.square_top_right.magenta": "Куе кызыл өске сул почмак",
  "block.minecraft.banner.square_top_right.orange": "Кызгылт сары өске сул почмак",
  "block.minecraft.banner.square_top_right.pink": "Ал өске сул почмак",
  "block.minecraft.banner.square_top_right.purple": "Шәмәхә өске сул почмак",
  "block.minecraft.banner.square_top_right.red": "Кызыл өске сул почмак",
  "block.minecraft.banner.square_top_right.white": "Ак өске сул почмак",
  "block.minecraft.banner.square_top_right.yellow": "Сары өске сул почмак",
  "block.minecraft.banner.straight_cross.black": "Кара тәре",
  "block.minecraft.banner.straight_cross.blue": "Зәңгәр тәре",
  "block.minecraft.banner.straight_cross.brown": "Көрән тәре",
  "block.minecraft.banner.straight_cross.cyan": "Фирәзә тәре",
  "block.minecraft.banner.straight_cross.gray": "Соры тәре",
  "block.minecraft.banner.straight_cross.green": "Яшел тәре",
  "block.minecraft.banner.straight_cross.light_blue": "Зәңгәрсу тәре",
  "block.minecraft.banner.straight_cross.light_gray": "Соргылт тәре",
  "block.minecraft.banner.straight_cross.lime": "Яшькелт тәре",
  "block.minecraft.banner.straight_cross.magenta": "Куе кызыл тәре",
  "block.minecraft.banner.straight_cross.orange": "Кызгылт сары тәре",
  "block.minecraft.banner.straight_cross.pink": "Ал тәре",
  "block.minecraft.banner.straight_cross.purple": "Шәмәхә тәре",
  "block.minecraft.banner.straight_cross.red": "Кызыл тәре",
  "block.minecraft.banner.straight_cross.white": "Ак тәре",
  "block.minecraft.banner.straight_cross.yellow": "Сары тәре",
  "block.minecraft.banner.stripe_bottom.black": "Кара нигез",
  "block.minecraft.banner.stripe_bottom.blue": "Зәңгәр нигез",
  "block.minecraft.banner.stripe_bottom.brown": "Көрән нигез",
  "block.minecraft.banner.stripe_bottom.cyan": "Фирәзә нигез",
  "block.minecraft.banner.stripe_bottom.gray": "Соры нигез",
  "block.minecraft.banner.stripe_bottom.green": "Яшел нигез",
  "block.minecraft.banner.stripe_bottom.light_blue": "Зәңгәрсу нигез",
  "block.minecraft.banner.stripe_bottom.light_gray": "Соргылт нигез",
  "block.minecraft.banner.stripe_bottom.lime": "Яшькелт нигез",
  "block.minecraft.banner.stripe_bottom.magenta": "Куе кызыл нигез",
  "block.minecraft.banner.stripe_bottom.orange": "Кызгылт сары нигез",
  "block.minecraft.banner.stripe_bottom.pink": "Ал нигез",
  "block.minecraft.banner.stripe_bottom.purple": "Шәмәхә нигез",
  "block.minecraft.banner.stripe_bottom.red": "Кызыл нигез",
  "block.minecraft.banner.stripe_bottom.white": "Ак нигез",
  "block.minecraft.banner.stripe_bottom.yellow": "Сары нигез",
  "block.minecraft.banner.stripe_center.black": "Кара багана",
  "block.minecraft.banner.stripe_center.blue": "Зәңгәр багана",
  "block.minecraft.banner.stripe_center.brown": "Көрән багана",
  "block.minecraft.banner.stripe_center.cyan": "Фирәзә багана",
  "block.minecraft.banner.stripe_center.gray": "Соры багана",
  "block.minecraft.banner.stripe_center.green": "Яшел багана",
  "block.minecraft.banner.stripe_center.light_blue": "Зәңгәрсу багана",
  "block.minecraft.banner.stripe_center.light_gray": "Соргылт багана",
  "block.minecraft.banner.stripe_center.lime": "Яшькелт багана",
  "block.minecraft.banner.stripe_center.magenta": "Куе кызыл багана",
  "block.minecraft.banner.stripe_center.orange": "Кызгылт сары багана",
  "block.minecraft.banner.stripe_center.pink": "Ал багана",
  "block.minecraft.banner.stripe_center.purple": "Шәмәхә багана",
  "block.minecraft.banner.stripe_center.red": "Кызыл багана",
  "block.minecraft.banner.stripe_center.white": "Ак багана",
  "block.minecraft.banner.stripe_center.yellow": "Сары багана",
  "block.minecraft.banner.stripe_downleft.black": "Кара кире авышлык",
  "block.minecraft.banner.stripe_downleft.blue": "Зәңгәр кире авышлык",
  "block.minecraft.banner.stripe_downleft.brown": "Көрән кире авышлык",
  "block.minecraft.banner.stripe_downleft.cyan": "Фирәзә кире авышлык",
  "block.minecraft.banner.stripe_downleft.gray": "Соры кире авышлык",
  "block.minecraft.banner.stripe_downleft.green": "Яшел кире авышлык",
  "block.minecraft.banner.stripe_downleft.light_blue": "Зәңгәрсу кире авышлык",
  "block.minecraft.banner.stripe_downleft.light_gray": "Соргылт кире авышлык",
  "block.minecraft.banner.stripe_downleft.lime": "Яшькелт кире авышлык",
  "block.minecraft.banner.stripe_downleft.magenta": "Куе кызыл кире авышлык",
  "block.minecraft.banner.stripe_downleft.orange": "Кызгылт сары кире авышлык",
  "block.minecraft.banner.stripe_downleft.pink": "Ал кире авышлык",
  "block.minecraft.banner.stripe_downleft.purple": "Шәмәхә кире авышлык",
  "block.minecraft.banner.stripe_downleft.red": "Кызыл кире авышлык",
  "block.minecraft.banner.stripe_downleft.white": "Ак кире авышлык",
  "block.minecraft.banner.stripe_downleft.yellow": "Сары кире авышлык",
  "block.minecraft.banner.stripe_downright.black": "Кара авышлык",
  "block.minecraft.banner.stripe_downright.blue": "Зәңгәр авышлык",
  "block.minecraft.banner.stripe_downright.brown": "Көрән авышлык",
  "block.minecraft.banner.stripe_downright.cyan": "Фирәзә авышлык",
  "block.minecraft.banner.stripe_downright.gray": "Соры авышлык",
  "block.minecraft.banner.stripe_downright.green": "Яшел авышлык",
  "block.minecraft.banner.stripe_downright.light_blue": "Зәңгәрсу авышлык",
  "block.minecraft.banner.stripe_downright.light_gray": "Соргылт авышлык",
  "block.minecraft.banner.stripe_downright.lime": "Яшькелт авышлык",
  "block.minecraft.banner.stripe_downright.magenta": "Куе кызыл авышлык",
  "block.minecraft.banner.stripe_downright.orange": "Кызгылт сары авышлык",
  "block.minecraft.banner.stripe_downright.pink": "Ал авышлык",
  "block.minecraft.banner.stripe_downright.purple": "Шәмәхә авышлык",
  "block.minecraft.banner.stripe_downright.red": "Кызыл авышлык",
  "block.minecraft.banner.stripe_downright.white": "Ак авышлык",
  "block.minecraft.banner.stripe_downright.yellow": "Сары авышлык",
  "block.minecraft.banner.stripe_left.black": "Кара уң багана",
  "block.minecraft.banner.stripe_left.blue": "Зәңгәр уң багана",
  "block.minecraft.banner.stripe_left.brown": "Көрән уң багана",
  "block.minecraft.banner.stripe_left.cyan": "Фирәзә уң багана",
  "block.minecraft.banner.stripe_left.gray": "Соры уң багана",
  "block.minecraft.banner.stripe_left.green": "Яшел уң багана",
  "block.minecraft.banner.stripe_left.light_blue": "Зәңгәрсу уң багана",
  "block.minecraft.banner.stripe_left.light_gray": "Соргылт уң багана",
  "block.minecraft.banner.stripe_left.lime": "Яшькелт уң багана",
  "block.minecraft.banner.stripe_left.magenta": "Куе кызыл уң багана",
  "block.minecraft.banner.stripe_left.orange": "Кызгылт сары уң багана",
  "block.minecraft.banner.stripe_left.pink": "Ал уң багана",
  "block.minecraft.banner.stripe_left.purple": "Шәмәхә уң багана",
  "block.minecraft.banner.stripe_left.red": "Кызыл уң багана",
  "block.minecraft.banner.stripe_left.white": "Ак уң багана",
  "block.minecraft.banner.stripe_left.yellow": "Сары уң багана",
  "block.minecraft.banner.stripe_middle.black": "Кара бил",
  "block.minecraft.banner.stripe_middle.blue": "Зәңгәр бил",
  "block.minecraft.banner.stripe_middle.brown": "Көрән бил",
  "block.minecraft.banner.stripe_middle.cyan": "Фирәзә бил",
  "block.minecraft.banner.stripe_middle.gray": "Соры бил",
  "block.minecraft.banner.stripe_middle.green": "Яшел бил",
  "block.minecraft.banner.stripe_middle.light_blue": "Зәңгәрсу бил",
  "block.minecraft.banner.stripe_middle.light_gray": "Соргылт бил",
  "block.minecraft.banner.stripe_middle.lime": "Яшькелт бил",
  "block.minecraft.banner.stripe_middle.magenta": "Куе кызыл бил",
  "block.minecraft.banner.stripe_middle.orange": "Кызгылт сары бил",
  "block.minecraft.banner.stripe_middle.pink": "Ал бил",
  "block.minecraft.banner.stripe_middle.purple": "Шәмәхә бил",
  "block.minecraft.banner.stripe_middle.red": "Кызыл бил",
  "block.minecraft.banner.stripe_middle.white": "Ак бил",
  "block.minecraft.banner.stripe_middle.yellow": "Сары бил",
  "block.minecraft.banner.stripe_right.black": "Кара сул багана",
  "block.minecraft.banner.stripe_right.blue": "Зәңгәр сул багана",
  "block.minecraft.banner.stripe_right.brown": "Көрән сул багана",
  "block.minecraft.banner.stripe_right.cyan": "Фирәзә сул багана",
  "block.minecraft.banner.stripe_right.gray": "Соры сул багана",
  "block.minecraft.banner.stripe_right.green": "Яшел сул багана",
  "block.minecraft.banner.stripe_right.light_blue": "Зәңгәрсу сул багана",
  "block.minecraft.banner.stripe_right.light_gray": "Соргылт сул багана",
  "block.minecraft.banner.stripe_right.lime": "Яшькелт сул багана",
  "block.minecraft.banner.stripe_right.magenta": "Куе кызыл сул багана",
  "block.minecraft.banner.stripe_right.orange": "Кызгылт сары сул багана",
  "block.minecraft.banner.stripe_right.pink": "Ал сул багана",
  "block.minecraft.banner.stripe_right.purple": "Шәмәхә сул багана",
  "block.minecraft.banner.stripe_right.red": "Кызыл сул багана",
  "block.minecraft.banner.stripe_right.white": "Ак сул багана",
  "block.minecraft.banner.stripe_right.yellow": "Сары сул багана",
  "block.minecraft.banner.stripe_top.black": "Кара оч",
  "block.minecraft.banner.stripe_top.blue": "Зәңгәр оч",
  "block.minecraft.banner.stripe_top.brown": "Көрән оч",
  "block.minecraft.banner.stripe_top.cyan": "Фирәзә оч",
  "block.minecraft.banner.stripe_top.gray": "Соры оч",
  "block.minecraft.banner.stripe_top.green": "Яшел оч",
  "block.minecraft.banner.stripe_top.light_blue": "Зәңгәрсу оч",
  "block.minecraft.banner.stripe_top.light_gray": "Соргылт оч",
  "block.minecraft.banner.stripe_top.lime": "Яшькелт оч",
  "block.minecraft.banner.stripe_top.magenta": "Куе кызыл оч",
  "block.minecraft.banner.stripe_top.orange": "Кызгылт сары оч",
  "block.minecraft.banner.stripe_top.pink": "Ал оч",
  "block.minecraft.banner.stripe_top.purple": "Шәмәхә оч",
  "block.minecraft.banner.stripe_top.red": "Кызыл оч",
  "block.minecraft.banner.stripe_top.white": "Ак оч",
  "block.minecraft.banner.stripe_top.yellow": "Сары оч",
  "block.minecraft.banner.triangle_bottom.black": "Кара оч",
  "block.minecraft.banner.triangle_bottom.blue": "Зәңгәр оч",
  "block.minecraft.banner.triangle_bottom.brown": "Көрән оч",
  "block.minecraft.banner.triangle_bottom.cyan": "Фирәзә оч",
  "block.minecraft.banner.triangle_bottom.gray": "Соры оч",
  "block.minecraft.banner.triangle_bottom.green": "Яшел оч",
  "block.minecraft.banner.triangle_bottom.light_blue": "Зәңгәрсу оч",
  "block.minecraft.banner.triangle_bottom.light_gray": "Соргылт оч",
  "block.minecraft.banner.triangle_bottom.lime": "Яшькелт оч",
  "block.minecraft.banner.triangle_bottom.magenta": "Куе кызыл оч",
  "block.minecraft.banner.triangle_bottom.orange": "Кызгылт сары оч",
  "block.minecraft.banner.triangle_bottom.pink": "Ал оч",
  "block.minecraft.banner.triangle_bottom.purple": "Шәмәхә оч",
  "block.minecraft.banner.triangle_bottom.red": "Кызыл оч",
  "block.minecraft.banner.triangle_bottom.white": "Ак оч",
  "block.minecraft.banner.triangle_bottom.yellow": "Сары оч",
  "block.minecraft.banner.triangle_top.black": "Кара аударылган оч",
  "block.minecraft.banner.triangle_top.blue": "Зәңгәр аударылган оч",
  "block.minecraft.banner.triangle_top.brown": "Көрән аударылган оч",
  "block.minecraft.banner.triangle_top.cyan": "Фирәзә аударылган оч",
  "block.minecraft.banner.triangle_top.gray": "Соры аударылган оч",
  "block.minecraft.banner.triangle_top.green": "Яшел аударылган оч",
  "block.minecraft.banner.triangle_top.light_blue": "Зәңгәрсу аударылган оч",
  "block.minecraft.banner.triangle_top.light_gray": "Соргылт аударылган оч",
  "block.minecraft.banner.triangle_top.lime": "Яшькелт аударылган оч",
  "block.minecraft.banner.triangle_top.magenta": "Куе кызыл аударылган оч",
  "block.minecraft.banner.triangle_top.orange": "Кызгылт сары аударылган оч",
  "block.minecraft.banner.triangle_top.pink": "Ал аударылган оч",
  "block.minecraft.banner.triangle_top.purple": "Шәмәхә аударылган оч",
  "block.minecraft.banner.triangle_top.red": "Кызыл аударылган оч",
  "block.minecraft.banner.triangle_top.white": "Ак аударылган оч",
  "block.minecraft.banner.triangle_top.yellow": "Сары аударылган оч",
  "block.minecraft.banner.triangles_bottom.black": "Кара тешле нигез",
  "block.minecraft.banner.triangles_bottom.blue": "Зәңгәрле тешле нигез",
  "block.minecraft.banner.triangles_bottom.brown": "Көрәнле тешле нигез",
  "block.minecraft.banner.triangles_bottom.cyan": "Фирәзә тешле нигез",
  "block.minecraft.banner.triangles_bottom.gray": "Соры тешле нигез",
  "block.minecraft.banner.triangles_bottom.green": "Яшел тешле нигез",
  "block.minecraft.banner.triangles_bottom.light_blue": "Зәңгәрсу тешле нигез",
  "block.minecraft.banner.triangles_bottom.light_gray": "Соргылт тешле нигез",
  "block.minecraft.banner.triangles_bottom.lime": "Яшькелт тешле нигез",
  "block.minecraft.banner.triangles_bottom.magenta": "Куе кызыл тешле нигез",
  "block.minecraft.banner.triangles_bottom.orange": "Кызгылт сары тешле нигез",
  "block.minecraft.banner.triangles_bottom.pink": "Ал тешле нигез",
  "block.minecraft.banner.triangles_bottom.purple": "Шәмәхә тешле нигез",
  "block.minecraft.banner.triangles_bottom.red": "Кызыл тешле нигез",
  "block.minecraft.banner.triangles_bottom.white": "Ак тешле нигез",
  "block.minecraft.banner.triangles_bottom.yellow": "Сары тешле нигез",
  "block.minecraft.banner.triangles_top.black": "Кара тешле баш",
  "block.minecraft.banner.triangles_top.blue": "Зәңгәрле тешле баш",
  "block.minecraft.banner.triangles_top.brown": "Көрәнле тешле баш",
  "block.minecraft.banner.triangles_top.cyan": "Фирәзә тешле баш",
  "block.minecraft.banner.triangles_top.gray": "Соры тешле баш",
  "block.minecraft.banner.triangles_top.green": "Яшел тешле баш",
  "block.minecraft.banner.triangles_top.light_blue": "Зәңгәрсу тешле баш",
  "block.minecraft.banner.triangles_top.light_gray": "Соргылт тешле баш",
  "block.minecraft.banner.triangles_top.lime": "Яшькелт тешле баш",
  "block.minecraft.banner.triangles_top.magenta": "Шәмәхә тешле баш",
  "block.minecraft.banner.triangles_top.orange": "Кызгылт сары тешле баш",
  "block.minecraft.banner.triangles_top.pink": "Ал тешле баш",
  "block.minecraft.banner.triangles_top.purple": "Шәмәхә тешле баш",
  "block.minecraft.banner.triangles_top.red": "Кызыл тешле баш",
  "block.minecraft.banner.triangles_top.white": "Ак тешле баш",
  "block.minecraft.banner.triangles_top.yellow": "Сары тешле баш",
  "block.minecraft.barrel": "Кисмәк",
  "block.minecraft.barrier": "Киртә",
  "block.minecraft.basalt": "Базальт",
  "block.minecraft.beacon": "Маяк",
  "block.minecraft.beacon.primary": "Төп тәэсир",
  "block.minecraft.beacon.secondary": "Икенче тәэсир",
  "block.minecraft.bed.no_sleep": "Сез төнлә яки яшен вакытында гына йоклый аласыз",
  "block.minecraft.bed.not_safe": "Сез йоклый алмыйсыз; янәшәдә җеннәр",
  "block.minecraft.bed.obstructed": "Бу карават буш түгел",
  "block.minecraft.bed.occupied": "Карават буш түгел",
  "block.minecraft.bed.too_far_away": "Сез йоклый алмыйсыз, карават ерак",
  "block.minecraft.bedrock": "Мендәрташ",
  "block.minecraft.bee_nest": "Корт оясы",
  "block.minecraft.beehive": "Умарта",
  "block.minecraft.beetroots": "Чөгендер",
  "block.minecraft.bell": "Чаң",
  "block.minecraft.big_dripleaf": "Зур тамчы яфрак",
  "block.minecraft.big_dripleaf_stem": "Зур тамчы яфрак сабагы",
  "block.minecraft.birch_button": "Каен төймә",
  "block.minecraft.birch_door": "Каен ишек",
  "block.minecraft.birch_fence": "Каен койма",
  "block.minecraft.birch_fence_gate": "Каен капка",
  "block.minecraft.birch_hanging_sign": "Элүле каен билге",
  "block.minecraft.birch_leaves": "Каен яфраклары",
  "block.minecraft.birch_log": "Каен бүрәнә",
  "block.minecraft.birch_planks": "Каен такталар",
  "block.minecraft.birch_pressure_plate": "Каен басма плитә",
  "block.minecraft.birch_sapling": "Каен үсентесе",
  "block.minecraft.birch_shelf": "Каен киштә",
  "block.minecraft.birch_sign": "Каен билге",
  "block.minecraft.birch_slab": "Каен плитә",
  "block.minecraft.birch_stairs": "Каен баскычлар",
  "block.minecraft.birch_trapdoor": "Каен люк",
  "block.minecraft.birch_wall_hanging_sign": "Элүле каен дивардагы билге",
  "block.minecraft.birch_wall_sign": "Каен дивардагы билге",
  "block.minecraft.birch_wood": "Каен",
  "block.minecraft.black_banner": "Кара байрак",
  "block.minecraft.black_bed": "Кара карават",
  "block.minecraft.black_candle": "Кара шәм",
  "block.minecraft.black_candle_cake": "Кара шәмле торт",
  "block.minecraft.black_carpet": "Кара келәм",
  "block.minecraft.black_concrete": "Кара бетон ",
  "block.minecraft.black_concrete_powder": "Кара коры бетон",
  "block.minecraft.black_glazed_terracotta": "Кара глазурьланган керамика",
  "block.minecraft.black_shulker_box": "Кара шалкер тартмасы",
  "block.minecraft.black_stained_glass": "Кара пыяла",
  "block.minecraft.black_stained_glass_pane": "Кара бизәкле пыяла панель",
  "block.minecraft.black_terracotta": "Кара керамика",
  "block.minecraft.black_wool": "Кара йон",
  "block.minecraft.blackstone": "Караташ",
  "block.minecraft.blackstone_slab": "Караташ плитә",
  "block.minecraft.blackstone_stairs": "Караташ баскычлар",
  "block.minecraft.blackstone_wall": "Караташ койма",
  "block.minecraft.blast_furnace": "Эретү миче",
  "block.minecraft.blue_banner": "Зәңгәр байрак",
  "block.minecraft.blue_bed": "Зәңгәр карават",
  "block.minecraft.blue_candle": "Зәңгәр шәм",
  "block.minecraft.blue_candle_cake": "Зәңгәр шәмле торт",
  "block.minecraft.blue_carpet": "Зәңгәр келәм",
  "block.minecraft.blue_concrete": "Зәңгәр бетон",
  "block.minecraft.blue_concrete_powder": "Зәңгәр коры бетон",
  "block.minecraft.blue_glazed_terracotta": "Зәңгәр глазурьланган керамика",
  "block.minecraft.blue_ice": "Зәңгәр боз",
  "block.minecraft.blue_orchid": "Зәңгәр күке яше",
  "block.minecraft.blue_shulker_box": "Зәңгәр шалкер тартмасы",
  "block.minecraft.blue_stained_glass": "Зәңгәр пыяла",
  "block.minecraft.blue_stained_glass_pane": "Зәңгәр бизәкле пыяла панель",
  "block.minecraft.blue_terracotta": "Зәңгәр керамика",
  "block.minecraft.blue_wool": "Зәңгәр йон",
  "block.minecraft.bone_block": "Сөяк блогы",
  "block.minecraft.bookshelf": "Китап киштәсе",
  "block.minecraft.brain_coral": "Ми мәрҗәне",
  "block.minecraft.brain_coral_block": "Ми мәрҗәне блогы",
  "block.minecraft.brain_coral_fan": "Ми мәрҗән җилпәзәсе",
  "block.minecraft.brain_coral_wall_fan": "Җилпәзә ятма ми-мәрҗән",
  "block.minecraft.brewing_stand": "Кайнаткыч",
  "block.minecraft.brick_slab": "Кирпеч плитә",
  "block.minecraft.brick_stairs": "Кирпеч баскычлар",
  "block.minecraft.brick_wall": "Кирпеч киртә",
  "block.minecraft.bricks": "Кирпечләр",
  "block.minecraft.brown_banner": "Көрән байрак",
  "block.minecraft.brown_bed": "Көрән карават",
  "block.minecraft.brown_candle": "Көрән шәм",
  "block.minecraft.brown_candle_cake": "Көрән шәмле торт",
  "block.minecraft.brown_carpet": "Көрән келәм",
  "block.minecraft.brown_concrete": "Көрән бетон",
  "block.minecraft.brown_concrete_powder": "Көрән коры бетон",
  "block.minecraft.brown_glazed_terracotta": "Көрән глазурьланган керамика",
  "block.minecraft.brown_mushroom": "Көрән гөмбә",
  "block.minecraft.brown_mushroom_block": "Көрән гөмбә блогы",
  "block.minecraft.brown_shulker_box": "Көрән шалкер тартмасы",
  "block.minecraft.brown_stained_glass": "Көрән пыяла",
  "block.minecraft.brown_stained_glass_pane": "Көрән бизәкле пыяла панель",
  "block.minecraft.brown_terracotta": "Көрән керамика",
  "block.minecraft.brown_wool": "Көрән йон",
  "block.minecraft.bubble_column": "Куыклар кәрваны",
  "block.minecraft.bubble_coral": "Куыклы мәрҗән",
  "block.minecraft.bubble_coral_block": "Куыклык мәрҗән блогы",
  "block.minecraft.bubble_coral_fan": "Җилпәзә куыклык мәрҗән",
  "block.minecraft.bubble_coral_wall_fan": "Җилпәзә ятма куыклык мәрҗән",
  "block.minecraft.budding_amethyst": "Чәчәк атучы аметист",
  "block.minecraft.bush": "Куак",
  "block.minecraft.cactus": "Кактус",
  "block.minecraft.cactus_flower": "Кактус чәчәге",
  "block.minecraft.cake": "Торт",
  "block.minecraft.calcite": "Кальцит",
  "block.minecraft.calibrated_sculk_sensor": "Калибрланган скалк сенсоры",
  "block.minecraft.campfire": "Учак",
  "block.minecraft.candle": "Шәм",
  "block.minecraft.candle_cake": "Шәмле торт",
  "block.minecraft.carrots": "Кишер",
  "block.minecraft.cartography_table": "Харитачы өстәле",
  "block.minecraft.carved_pumpkin": "Киселгән кабак",
  "block.minecraft.cauldron": "Казан",
  "block.minecraft.cave_air": "Мәгарә һавасы",
  "block.minecraft.cave_vines": "Мәгарә чыбыгы",
  "block.minecraft.cave_vines_plant": "Мәгарә чыбык сабагы",
  "block.minecraft.chain": "Чылбыр",
  "block.minecraft.chain_command_block": "Эзлекле боерык блок",
  "block.minecraft.cherry_button": "Чия төймә",
  "block.minecraft.cherry_door": "Чия ишек",
  "block.minecraft.cherry_fence": "Чия койма",
  "block.minecraft.cherry_fence_gate": "Чия капка",
  "block.minecraft.cherry_hanging_sign": "Элүле чия билге",
  "block.minecraft.cherry_leaves": "Чия яфраклары",
  "block.minecraft.cherry_log": "Чия бүрәнә",
  "block.minecraft.cherry_planks": "Чия такталар",
  "block.minecraft.cherry_pressure_plate": "Чия басма плитә",
  "block.minecraft.cherry_sapling": "Чия үсентесе",
  "block.minecraft.cherry_shelf": "Чия киштә",
  "block.minecraft.cherry_sign": "Чия билге",
  "block.minecraft.cherry_slab": "Чия плитә",
  "block.minecraft.cherry_stairs": "Чия баскычлар",
  "block.minecraft.cherry_trapdoor": "Чия люк",
  "block.minecraft.cherry_wall_hanging_sign": "Элүле чия дивардагы билге",
  "block.minecraft.cherry_wall_sign": "Чия дивардагы билге",
  "block.minecraft.cherry_wood": "Чия агачы",
  "block.minecraft.chest": "Сандык",
  "block.minecraft.chipped_anvil": "Бозылган сандал",
  "block.minecraft.chiseled_bookshelf": "Уелган китап киштәсе",
  "block.minecraft.chiseled_copper": "Уелган бакыр блок",
  "block.minecraft.chiseled_deepslate": "Уелган тирән сланец",
  "block.minecraft.chiseled_nether_bricks": "Уелган незер кирпечләре",
  "block.minecraft.chiseled_polished_blackstone": "Уелган шомартылган караташ",
  "block.minecraft.chiseled_quartz_block": "Кисек кварц блок",
  "block.minecraft.chiseled_red_sandstone": "Уелган кызыл комташ",
  "block.minecraft.chiseled_resin_bricks": "Уелган сагыз кирпечләре",
  "block.minecraft.chiseled_sandstone": "Уелган комташ",
  "block.minecraft.chiseled_stone_bricks": "Уелган таш кирпечләр",
  "block.minecraft.chiseled_tuff": "Уелган туф",
  "block.minecraft.chiseled_tuff_bricks": "Уелган туф кирпечләр",
  "block.minecraft.chorus_flower": "Хорус чәчәге",
  "block.minecraft.chorus_plant": "Хорус",
  "block.minecraft.clay": "Балчык",
  "block.minecraft.closed_eyeblossom": "Ябык күзгөл",
  "block.minecraft.coal_block": "Күмер блок",
  "block.minecraft.coal_ore": "Күмер мәгъдәне",
  "block.minecraft.coarse_dirt": "Ташлы җир",
  "block.minecraft.cobbled_deepslate": "Вакланган тирән сланец",
  "block.minecraft.cobbled_deepslate_slab": "Вакланган тирән сланец плитә",
  "block.minecraft.cobbled_deepslate_stairs": "Вакланган тирән сланец баскычлар",
  "block.minecraft.cobbled_deepslate_wall": "Вакланган тирән сланец киртә",
  "block.minecraft.cobblestone": "Йомрыташ",
  "block.minecraft.cobblestone_slab": "Йомрыташ плитә",
  "block.minecraft.cobblestone_stairs": "Йомрыташ баскычлар",
  "block.minecraft.cobblestone_wall": "Йомрыташ киртә",
  "block.minecraft.cobweb": "Пәрәвез",
  "block.minecraft.cocoa": "Какао",
  "block.minecraft.command_block": "Боерык блок",
  "block.minecraft.comparator": "Редстоун компаратор",
  "block.minecraft.composter": "Череткеч",
  "block.minecraft.conduit": "Диңгез чыганагы",
  "block.minecraft.copper_bars": "Бакыр рәшәткәләр",
  "block.minecraft.copper_block": "Бакыр блок",
  "block.minecraft.copper_bulb": "Бакыр лампа",
  "block.minecraft.copper_chain": "Бакыр чылбыр",
  "block.minecraft.copper_chest": "Бакыр сандык",
  "block.minecraft.copper_door": "Бакыр ишек",
  "block.minecraft.copper_golem_statue": "Бакыр голем сыны",
  "block.minecraft.copper_grate": "Бакыр рәшәткә",
  "block.minecraft.copper_lantern": "Бакыр фонарь",
  "block.minecraft.copper_ore": "Бакыр мәгъдәне",
  "block.minecraft.copper_torch": "Бакыр факел",
  "block.minecraft.copper_trapdoor": "Бакыр люк",
  "block.minecraft.copper_wall_torch": "Дивардагы бакыр факел",
  "block.minecraft.cornflower": "Күкчәчәк",
  "block.minecraft.cracked_deepslate_bricks": "Ярылган тирән сланец кирпечләре",
  "block.minecraft.cracked_deepslate_tiles": "Ярылган тирән сланец кафеле",
  "block.minecraft.cracked_nether_bricks": "Ярылган незер кирпечләре",
  "block.minecraft.cracked_polished_blackstone_bricks": "Ярылган шомартылган караташ кирпечләр",
  "block.minecraft.cracked_stone_bricks": "Ярылган таш кирпечләр",
  "block.minecraft.crafter": "Җыйгыч",
  "block.minecraft.crafting_table": "Верстак",
  "block.minecraft.creaking_heart": "Шакылдаучы йөрәк",
  "block.minecraft.creeper_head": "Крипер башы",
  "block.minecraft.creeper_wall_head": "Стена крипер башы",
  "block.minecraft.crimson_button": "Кырмызы төймә",
  "block.minecraft.crimson_door": "Кырмызы ишек",
  "block.minecraft.crimson_fence": "Кырмызы койма",
  "block.minecraft.crimson_fence_gate": "Кырмызы капка",
  "block.minecraft.crimson_fungus": "Кырмызы гөмбә",
  "block.minecraft.crimson_hanging_sign": "Элүле кырмызы билге",
  "block.minecraft.crimson_hyphae": "Кырмызы җепселләр",
  "block.minecraft.crimson_nylium": "Кырмызы нәлек",
  "block.minecraft.crimson_planks": "Кырмызы такталар",
  "block.minecraft.crimson_pressure_plate": "Кырмызы басма плитә",
  "block.minecraft.crimson_roots": "Кырмызы тамырлар",
  "block.minecraft.crimson_shelf": "Кырмызы киштә",
  "block.minecraft.crimson_sign": "Кырмызы билге",
  "block.minecraft.crimson_slab": "Кырмызы плитә",
  "block.minecraft.crimson_stairs": "Кырмызы баскычлар",
  "block.minecraft.crimson_stem": "Кырмызы сабак",
  "block.minecraft.crimson_trapdoor": "Кырмызы люк",
  "block.minecraft.crimson_wall_hanging_sign": "Элүле кырмызы дивардагы билге",
  "block.minecraft.crimson_wall_sign": "Кырмызы дивар билгесе",
  "block.minecraft.crying_obsidian": "Елаучы обсидиан",
  "block.minecraft.cut_copper": "Киселгән бакыр",
  "block.minecraft.cut_copper_slab": "Киселгән бакыр плитә",
  "block.minecraft.cut_copper_stairs": "Киселгән бакыр баскычлар",
  "block.minecraft.cut_red_sandstone": "Шома кызыл комташ",
  "block.minecraft.cut_red_sandstone_slab": "Шома кызыл комташ плитә",
  "block.minecraft.cut_sandstone": "Шома комташ",
  "block.minecraft.cut_sandstone_slab": "Шома комташ плитә",
  "block.minecraft.cyan_banner": "Фирәзә байрак",
  "block.minecraft.cyan_bed": "Фирәзә карават",
  "block.minecraft.cyan_candle": "Фирәзә шәм",
  "block.minecraft.cyan_candle_cake": "Фирәзә шәмле торт",
  "block.minecraft.cyan_carpet": "Фирәзә келәм",
  "block.minecraft.cyan_concrete": "Фирәзә бетон",
  "block.minecraft.cyan_concrete_powder": "Фирәзә коры бетон",
  "block.minecraft.cyan_glazed_terracotta": "Фирәзә глазурьланган керамика",
  "block.minecraft.cyan_shulker_box": "Фирәзә шалкер тартмасы",
  "block.minecraft.cyan_stained_glass": "Фирәзә пыяла",
  "block.minecraft.cyan_stained_glass_pane": "Фирәзә бизәкле пыяла панель",
  "block.minecraft.cyan_terracotta": "Фирәзә керамика",
  "block.minecraft.cyan_wool": "Фирәзә йон",
  "block.minecraft.damaged_anvil": "Ватылган сандал",
  "block.minecraft.dandelion": "Тузганак",
  "block.minecraft.dark_oak_button": "Кара имән төймә",
  "block.minecraft.dark_oak_door": "Кара имән ишек",
  "block.minecraft.dark_oak_fence": "Кара имән койма",
  "block.minecraft.dark_oak_fence_gate": "Кара имән капка",
  "block.minecraft.dark_oak_hanging_sign": "Элүле кара имән билге",
  "block.minecraft.dark_oak_leaves": "Кара имән яфраклары",
  "block.minecraft.dark_oak_log": "Кара имән бүрәнә",
  "block.minecraft.dark_oak_planks": "Кара имән такталар",
  "block.minecraft.dark_oak_pressure_plate": "Кара имән басма плитә",
  "block.minecraft.dark_oak_sapling": "Кара имән үсентесе",
  "block.minecraft.dark_oak_shelf": "Кара имән киштә",
  "block.minecraft.dark_oak_sign": "Кара имән билге",
  "block.minecraft.dark_oak_slab": "Кара имән плитә",
  "block.minecraft.dark_oak_stairs": "Кара имән баскычлар",
  "block.minecraft.dark_oak_trapdoor": "Кара имән люк",
  "block.minecraft.dark_oak_wall_hanging_sign": "Элүле кара имән дивардагы билге",
  "block.minecraft.dark_oak_wall_sign": "Кара имән дивардагы билге",
  "block.minecraft.dark_oak_wood": "Кара имән",
  "block.minecraft.dark_prismarine": "Кара призмарин",
  "block.minecraft.dark_prismarine_slab": "Кара призмарин плитә",
  "block.minecraft.dark_prismarine_stairs": "Кара призмарин баскычлар",
  "block.minecraft.daylight_detector": "Көндезге яктылык детекторы",
  "block.minecraft.dead_brain_coral": "Үле ми мәрҗән",
  "block.minecraft.dead_brain_coral_block": "Үле ми мәрҗән блогы",
  "block.minecraft.dead_brain_coral_fan": "Үле җилпәзә ми мәрҗән",
  "block.minecraft.dead_brain_coral_wall_fan": "Үле ятма җилпәзә ми мәрҗән",
  "block.minecraft.dead_bubble_coral": "Үле куыклык мәрҗән",
  "block.minecraft.dead_bubble_coral_block": "Үле куыклык мәрҗән блогы",
  "block.minecraft.dead_bubble_coral_fan": "Үле җилпәзә куыклык мәрҗән",
  "block.minecraft.dead_bubble_coral_wall_fan": "Үле ятма җилпәзә куыклык мәрҗән",
  "block.minecraft.dead_bush": "Үле куак",
  "block.minecraft.dead_fire_coral": "Үле ут мәрҗән",
  "block.minecraft.dead_fire_coral_block": "Үле ут мәрҗән блогы",
  "block.minecraft.dead_fire_coral_fan": "Үле җилпәзә ут мәрҗән",
  "block.minecraft.dead_fire_coral_wall_fan": "Үле ятма җилпәзә ут мәрҗән",
  "block.minecraft.dead_horn_coral": "Үле мөгез мәрҗән",
  "block.minecraft.dead_horn_coral_block": "Үле мөгез мәрҗән блогы",
  "block.minecraft.dead_horn_coral_fan": "Үле җилпәзә мөгез мәрҗән",
  "block.minecraft.dead_horn_coral_wall_fan": "Үле ятма җилпәзә мөгез мәрҗән",
  "block.minecraft.dead_tube_coral": "Үле торбасыман мәрҗән",
  "block.minecraft.dead_tube_coral_block": "Үле торбасыман мәрҗән блогы",
  "block.minecraft.dead_tube_coral_fan": "Үле җилпәзә торбасыман мәрҗән",
  "block.minecraft.dead_tube_coral_wall_fan": "Үле ятма җилпәзә торбасыман мәрҗән",
  "block.minecraft.decorated_pot": "Бизәкле чүлмәк",
  "block.minecraft.deepslate": "Тирән сланец",
  "block.minecraft.deepslate_brick_slab": "Тирән сланец кирпеч плитә",
  "block.minecraft.deepslate_brick_stairs": "Тирән сланец кирпеч баскычлар",
  "block.minecraft.deepslate_brick_wall": "Тирән сланец кирпеч киртә",
  "block.minecraft.deepslate_bricks": "Тирән сланец кирпечләре",
  "block.minecraft.deepslate_coal_ore": "Күмерле тирән сланец мәгъдәне",
  "block.minecraft.deepslate_copper_ore": "Бакырлы тирән сланец мәгъдәне",
  "block.minecraft.deepslate_diamond_ore": "Алмазлы тирән сланец мәгъдәне",
  "block.minecraft.deepslate_emerald_ore": "Зөбәрҗәтле тирән сланец мәгъдәне",
  "block.minecraft.deepslate_gold_ore": "Алтынлы тирән сланец мәгъдәне",
  "block.minecraft.deepslate_iron_ore": "Тимерле тирән сланец мәгъдәне",
  "block.minecraft.deepslate_lapis_ore": "Лазуритлы тирән сланец мәгъдәне",
  "block.minecraft.deepslate_redstone_ore": "Редстоунлы тирән сланец мәгъдәне",
  "block.minecraft.deepslate_tile_slab": "Тирән сланец кафеле плитә",
  "block.minecraft.deepslate_tile_stairs": "Тирән сланец кафеле баскычлар",
  "block.minecraft.deepslate_tile_wall": "Тирән сланец кафеле киртә",
  "block.minecraft.deepslate_tiles": "Тирән сланец кафеле",
  "block.minecraft.detector_rail": "Детекторлы тимер юл",
  "block.minecraft.diamond_block": "Алмаз блок",
  "block.minecraft.diamond_ore": "Алмаз мәгъдәне",
  "block.minecraft.diorite": "Диорит",
  "block.minecraft.diorite_slab": "Диорит плитә",
  "block.minecraft.diorite_stairs": "Диорит баскычлар",
  "block.minecraft.diorite_wall": "Диорит киртә",
  "block.minecraft.dirt": "Җир",
  "block.minecraft.dirt_path": "Сукмак",
  "block.minecraft.dispenser": "Өләшкеч",
  "block.minecraft.dragon_egg": "Аҗдаһа йомыркасы",
  "block.minecraft.dragon_head": "Аҗдаһа башы",
  "block.minecraft.dragon_wall_head": "Стена аждаһа башы",
  "block.minecraft.dried_ghast": "Киптерелгән гаст",
  "block.minecraft.dried_kelp_block": "Кипкән суүсем блогы",
  "block.minecraft.dripstone_block": "Тамчыташ блогы",
  "block.minecraft.dropper": "Ташлаткыч",
  "block.minecraft.emerald_block": "Зөбәрҗәт блок",
  "block.minecraft.emerald_ore": "Зөбәрҗәт мәгъдәне",
  "block.minecraft.enchanting_table": "Сихер өстәле",
  "block.minecraft.end_gateway": "Энд капкасы",
  "block.minecraft.end_portal": "Энд порталы",
  "block.minecraft.end_portal_frame": "Эндка портал кысачыгы",
  "block.minecraft.end_rod": "Энд таягы",
  "block.minecraft.end_stone": "Эндерташ",
  "block.minecraft.end_stone_brick_slab": "Эндерташ кирпеч плитә",
  "block.minecraft.end_stone_brick_stairs": "Эндерташ кирпеч баскычлар",
  "block.minecraft.end_stone_brick_wall": "Эндерташ кирпеч киртә",
  "block.minecraft.end_stone_bricks": "Эндерташ кирпечләр",
  "block.minecraft.ender_chest": "Эндер-сандык",
  "block.minecraft.exposed_chiseled_copper": "Караланган уелган бакыр",
  "block.minecraft.exposed_copper": "Караланган бакыр блок",
  "block.minecraft.exposed_copper_bars": "Караланган бакыр рәшәткәләр",
  "block.minecraft.exposed_copper_bulb": "Караланган бакыр лампа",
  "block.minecraft.exposed_copper_chain": "Караланган бакыр чылбыр",
  "block.minecraft.exposed_copper_chest": "Караланган бакыр сандык",
  "block.minecraft.exposed_copper_door": "Караланган бакыр ишек",
  "block.minecraft.exposed_copper_golem_statue": "Караланган бакыр голем сыны",
  "block.minecraft.exposed_copper_grate": "Караланган бакыр рәшәткә",
  "block.minecraft.exposed_copper_lantern": "Караланган бакыр фонарь",
  "block.minecraft.exposed_copper_trapdoor": "Караланган бакыр люк",
  "block.minecraft.exposed_cut_copper": "Караланган киселгән бакыр",
  "block.minecraft.exposed_cut_copper_slab": "Караланган киселгән бакыр плитә",
  "block.minecraft.exposed_cut_copper_stairs": "Караланган киселгән бакыр баскычлар",
  "block.minecraft.exposed_lightning_rod": "Караланган яшен кайтаргыч",
  "block.minecraft.farmland": "Сөрүлек",
  "block.minecraft.fern": "Абага",
  "block.minecraft.fire": "Ялкын",
  "block.minecraft.fire_coral": "Ут мәрҗән",
  "block.minecraft.fire_coral_block": "Ут мәрҗән блогы",
  "block.minecraft.fire_coral_fan": "Җилпәзә ут мәрҗән",
  "block.minecraft.fire_coral_wall_fan": "Җилпәзә ятма ут мәрҗән",
  "block.minecraft.firefly_bush": "Тычкан уты куагы",
  "block.minecraft.fletching_table": "Җәяче өстәле",
  "block.minecraft.flower_pot": "Чәчәк чүлмәге",
  "block.minecraft.flowering_azalea": "Чәчәк аткан азалия",
  "block.minecraft.flowering_azalea_leaves": "Чәчәк аткан азалия яфраклары",
  "block.minecraft.frogspawn": "Бака уылдыгы",
  "block.minecraft.frosted_ice": "Эрегән боз",
  "block.minecraft.furnace": "Мич",
  "block.minecraft.gilded_blackstone": "Алтынланган караташ",
  "block.minecraft.glass": "Пыяла",
  "block.minecraft.glass_pane": "Пыяла панель",
  "block.minecraft.glow_lichen": "Нурлы мүк",
  "block.minecraft.glowstone": "Яктыташ",
  "block.minecraft.gold_block": "Алтын блок",
  "block.minecraft.gold_ore": "Алтын мәгъдәне",
  "block.minecraft.golden_dandelion": "Алтын тузганак",
  "block.minecraft.granite": "Гранит",
  "block.minecraft.granite_slab": "Гранит плитә",
  "block.minecraft.granite_stairs": "Гранит баскычлар",
  "block.minecraft.granite_wall": "Гранит киртә",
  "block.minecraft.grass": "Үлән",
  "block.minecraft.grass_block": "Кәс",
  "block.minecraft.gravel": "Чуерташ",
  "block.minecraft.gray_banner": "Соры байрак",
  "block.minecraft.gray_bed": "Соры карават",
  "block.minecraft.gray_candle": "Соры шәм",
  "block.minecraft.gray_candle_cake": "Соры шәмле торт",
  "block.minecraft.gray_carpet": "Соры келәм",
  "block.minecraft.gray_concrete": "Соры бетон",
  "block.minecraft.gray_concrete_powder": "Соры коры бетон",
  "block.minecraft.gray_glazed_terracotta": "Соры глазурьланган керамика",
  "block.minecraft.gray_shulker_box": "Соры шалкер тартмасы",
  "block.minecraft.gray_stained_glass": "Соры пыяла",
  "block.minecraft.gray_stained_glass_pane": "Соры бизәкле пыяла панель",
  "block.minecraft.gray_terracotta": "Соры керамика",
  "block.minecraft.gray_wool": "Соры йон",
  "block.minecraft.green_banner": "Яшел байрак",
  "block.minecraft.green_bed": "Яшел карават",
  "block.minecraft.green_candle": "Яшел шәм",
  "block.minecraft.green_candle_cake": "Яшел шәмле торт",
  "block.minecraft.green_carpet": "Яшел келәм",
  "block.minecraft.green_concrete": "Яшел бетон",
  "block.minecraft.green_concrete_powder": "Яшел коры бетон",
  "block.minecraft.green_glazed_terracotta": "Яшел глазурьланган керамика",
  "block.minecraft.green_shulker_box": "Яшел шалкер тартмасы",
  "block.minecraft.green_stained_glass": "Яшел пыяла",
  "block.minecraft.green_stained_glass_pane": "Яшел бизәкле пыяла панель",
  "block.minecraft.green_terracotta": "Яшел керамика",
  "block.minecraft.green_wool": "Яшел йон",
  "block.minecraft.grindstone": "Кайрак",
  "block.minecraft.hanging_roots": "Салынкы тамырлар",
  "block.minecraft.hay_block": "Печән бәйләме",
  "block.minecraft.heavy_core": "Авыр үзәк",
  "block.minecraft.heavy_weighted_pressure_plate": "Салмакрак авырлык плитә",
  "block.minecraft.honey_block": "Бал блогы",
  "block.minecraft.honeycomb_block": "Корт кәрәзләр блогы",
  "block.minecraft.hopper": "Бүрәнкә",
  "block.minecraft.horn_coral": "Мөгез мәрҗән",
  "block.minecraft.horn_coral_block": "Мөгез мәрҗән блогы",
  "block.minecraft.horn_coral_fan": "Җилпәзә мөгез мәрҗән",
  "block.minecraft.horn_coral_wall_fan": "Җилпәзә ятма мөгез мәрҗән",
  "block.minecraft.ice": "Боз",
  "block.minecraft.infested_chiseled_stone_bricks": "Йоктырылган уелган таш кирпечләр",
  "block.minecraft.infested_cobblestone": "Йоктырылган йомрыташ",
  "block.minecraft.infested_cracked_stone_bricks": "Йоктырылган ярылган таш кирпечләр",
  "block.minecraft.infested_deepslate": "Йоктырылган тирән сланец",
  "block.minecraft.infested_mossy_stone_bricks": "Йоктырылган мүкле таш кирпечләр",
  "block.minecraft.infested_stone": "Йоктырылган таш",
  "block.minecraft.infested_stone_bricks": "Йоктырылган таш кирпечләр",
  "block.minecraft.iron_bars": "Тимер рәшәткәләр",
  "block.minecraft.iron_block": "Тимер блок",
  "block.minecraft.iron_chain": "Тимер чылбыр",
  "block.minecraft.iron_door": "Тимер ишек",
  "block.minecraft.iron_ore": "Тимер мәгъдәне",
  "block.minecraft.iron_trapdoor": "Тимер люк",
  "block.minecraft.jack_o_lantern": "Джек яктырткычы",
  "block.minecraft.jigsaw": "Пазл",
  "block.minecraft.jukebox": "Уйнаткыч",
  "block.minecraft.jungle_button": "Тропик агач төймә",
  "block.minecraft.jungle_door": "Тропик агач ишек",
  "block.minecraft.jungle_fence": "Тропик агач койма",
  "block.minecraft.jungle_fence_gate": "Тропик агач капка",
  "block.minecraft.jungle_hanging_sign": "Элүле тропик билге",
  "block.minecraft.jungle_leaves": "Тропик агач яфраклары",
  "block.minecraft.jungle_log": "Тропик агач бүрәнә",
  "block.minecraft.jungle_planks": "Тропик агач такталар",
  "block.minecraft.jungle_pressure_plate": "Тропик агач басма плитә",
  "block.minecraft.jungle_sapling": "Тропик агач үсентесе",
  "block.minecraft.jungle_shelf": "Тропик киштә",
  "block.minecraft.jungle_sign": "Тропик агач билге",
  "block.minecraft.jungle_slab": "Тропик агач плитә",
  "block.minecraft.jungle_stairs": "Тропик агач баскычлар",
  "block.minecraft.jungle_trapdoor": "Тропик агач люк",
  "block.minecraft.jungle_wall_hanging_sign": "Элүле тропик дивардагы билге",
  "block.minecraft.jungle_wall_sign": "Тропик агач дивардагы билге",
  "block.minecraft.jungle_wood": "Тропик агач",
  "block.minecraft.kelp": "Суүсем",
  "block.minecraft.kelp_plant": "Суүсем сабагы",
  "block.minecraft.ladder": "Баскыч",
  "block.minecraft.lantern": "Фонарь",
  "block.minecraft.lapis_block": "Лазурит блок",
  "block.minecraft.lapis_ore": "Лазурит мәгъдәне",
  "block.minecraft.large_amethyst_bud": "Эре аметист бәйләме",
  "block.minecraft.large_fern": "Эре абага",
  "block.minecraft.lava": "Лава",
  "block.minecraft.lava_cauldron": "Лавалы казан",
  "block.minecraft.leaf_litter": "Коелган яфраклар",
  "block.minecraft.lectern": "Кафедра",
  "block.minecraft.lever": "Көянтә",
  "block.minecraft.light": "Яктылык",
  "block.minecraft.light_blue_banner": "Зәңгәрсу байрак",
  "block.minecraft.light_blue_bed": "Зәңгәрсу карават",
  "block.minecraft.light_blue_candle": "Зәңгәрсу шәм",
  "block.minecraft.light_blue_candle_cake": "Зәңгәрсу шәмле торт",
  "block.minecraft.light_blue_carpet": "Зәңгәрсу келәм",
  "block.minecraft.light_blue_concrete": "Зәңгәрсу бетон",
  "block.minecraft.light_blue_concrete_powder": "Зәңгәрсу коры бетон",
  "block.minecraft.light_blue_glazed_terracotta": "Зәңгәрсу глазурьланган керамика",
  "block.minecraft.light_blue_shulker_box": "Зәңгәрсу шалкер тартмасы",
  "block.minecraft.light_blue_stained_glass": "Зәңгәрсу пыяла",
  "block.minecraft.light_blue_stained_glass_pane": "Зәңгәрсу бизәкле пыяла панель",
  "block.minecraft.light_blue_terracotta": "Зәңгәрсу керамика",
  "block.minecraft.light_blue_wool": "Зәңгәрсу йон",
  "block.minecraft.light_gray_banner": "Соргылт байрак",
  "block.minecraft.light_gray_bed": "Соргылт карават",
  "block.minecraft.light_gray_candle": "Соргылт шәм",
  "block.minecraft.light_gray_candle_cake": "Соргылт шәмле торт",
  "block.minecraft.light_gray_carpet": "Соргылт келәм",
  "block.minecraft.light_gray_concrete": "Соргылт бетон",
  "block.minecraft.light_gray_concrete_powder": "Соргылт коры бетон",
  "block.minecraft.light_gray_glazed_terracotta": "Соргылт глазурьланган керамика",
  "block.minecraft.light_gray_shulker_box": "Соргылт шалкер тартмасы",
  "block.minecraft.light_gray_stained_glass": "Соргылт пыяла",
  "block.minecraft.light_gray_stained_glass_pane": "Соргылт бизәкле пыяла панель",
  "block.minecraft.light_gray_terracotta": "Соргылт керамика",
  "block.minecraft.light_gray_wool": "Соргылт йон",
  "block.minecraft.light_weighted_pressure_plate": "Авырлык плитә",
  "block.minecraft.lightning_rod": "Яшен кайтаргыч",
  "block.minecraft.lilac": "Канәфер",
  "block.minecraft.lily_of_the_valley": "Энҗе чәчәк",
  "block.minecraft.lily_pad": "Төнбөек",
  "block.minecraft.lime_banner": "Яшькелт байрак",
  "block.minecraft.lime_bed": "Яшькелт карават",
  "block.minecraft.lime_candle": "Яшькелт шәм",
  "block.minecraft.lime_candle_cake": "Яшькелт шәмле торт",
  "block.minecraft.lime_carpet": "Яшькелт келәм",
  "block.minecraft.lime_concrete": "Яшькелт бетон",
  "block.minecraft.lime_concrete_powder": "Яшькелт коры бетон",
  "block.minecraft.lime_glazed_terracotta": "Яшькелт глазурьланган керамика",
  "block.minecraft.lime_shulker_box": "Яшькелт шалкер тартмасы",
  "block.minecraft.lime_stained_glass": "Яшькелт пыяла",
  "block.minecraft.lime_stained_glass_pane": "Яшькелт бизәкле пыяла панель",
  "block.minecraft.lime_terracotta": "Яшькелт керамика",
  "block.minecraft.lime_wool": "Яшькелт йон",
  "block.minecraft.lodestone": "Магнетит",
  "block.minecraft.loom": "Туку станы",
  "block.minecraft.magenta_banner": "Куе кызыл байрак",
  "block.minecraft.magenta_bed": "Куе кызыл карават",
  "block.minecraft.magenta_candle": "Куе кызыл шәм",
  "block.minecraft.magenta_candle_cake": "Куе кызыл шәмле торт",
  "block.minecraft.magenta_carpet": "Куе кызыл келәм",
  "block.minecraft.magenta_concrete": "Куе кызыл бетон",
  "block.minecraft.magenta_concrete_powder": "Куе кызыл коры бетон",
  "block.minecraft.magenta_glazed_terracotta": "Куе кызыл глазурьланган керамика",
  "block.minecraft.magenta_shulker_box": "Куе кызыл шалкер тартмасы",
  "block.minecraft.magenta_stained_glass": "Куе кызыл пыяла",
  "block.minecraft.magenta_stained_glass_pane": "Куе кызыл бизәкле пыяла панель",
  "block.minecraft.magenta_terracotta": "Куе кызыл керамика",
  "block.minecraft.magenta_wool": "Куе кызыл йон",
  "block.minecraft.magma_block": "Магма",
  "block.minecraft.mangrove_button": "Мангр төймә",
  "block.minecraft.mangrove_door": "Мангр ишек",
  "block.minecraft.mangrove_fence": "Мангр койма",
  "block.minecraft.mangrove_fence_gate": "Мангр капка",
  "block.minecraft.mangrove_hanging_sign": "Элүле мангр билге",
  "block.minecraft.mangrove_leaves": "Мангр яфраклары",
  "block.minecraft.mangrove_log": "Мангр бүрәнә",
  "block.minecraft.mangrove_planks": "Мангр такталар",
  "block.minecraft.mangrove_pressure_plate": "Мангр басма плитә",
  "block.minecraft.mangrove_propagule": "Мангр сабы",
  "block.minecraft.mangrove_roots": "Мангр тамырлар",
  "block.minecraft.mangrove_shelf": "Мангр киштә",
  "block.minecraft.mangrove_sign": "Мангр билге",
  "block.minecraft.mangrove_slab": "Мангр плитә",
  "block.minecraft.mangrove_stairs": "Мангр баскычлар",
  "block.minecraft.mangrove_trapdoor": "Мангр люк",
  "block.minecraft.mangrove_wall_hanging_sign": "Элүле мангр дивардагы билге",
  "block.minecraft.mangrove_wall_sign": "Мангр дивардагы билге",
  "block.minecraft.mangrove_wood": "Мангр",
  "block.minecraft.medium_amethyst_bud": "Уртача аметист бәйләме",
  "block.minecraft.melon": "Карбыз",
  "block.minecraft.melon_stem": "Карбыз сабагы",
  "block.minecraft.moss_block": "Мүк блогы",
  "block.minecraft.moss_carpet": "Мүк келәме",
  "block.minecraft.mossy_cobblestone": "Мүкле йомрыташ",
  "block.minecraft.mossy_cobblestone_slab": "Мүкле йомрыташ плитә",
  "block.minecraft.mossy_cobblestone_stairs": "Мүкле йомрыташ баскычлар",
  "block.minecraft.mossy_cobblestone_wall": "Мүкле йомрыташ киртә",
  "block.minecraft.mossy_stone_brick_slab": "Мүкле таш кирпеч плитә",
  "block.minecraft.mossy_stone_brick_stairs": "Мүкле таш кирпеч баскычлар",
  "block.minecraft.mossy_stone_brick_wall": "Мүкле таш кирпеч киртә",
  "block.minecraft.mossy_stone_bricks": "Мүкле таш кирпечләр",
  "block.minecraft.moving_piston": "Бара торган пешкәк",
  "block.minecraft.mud": "Пычрак",
  "block.minecraft.mud_brick_slab": "Саман кирпеч плитәсе",
  "block.minecraft.mud_brick_stairs": "Саман кирпеч баскычлары",
  "block.minecraft.mud_brick_wall": "Саман кирпеч киртәсе",
  "block.minecraft.mud_bricks": "Саман кирпечләре",
  "block.minecraft.muddy_mangrove_roots": "Пычрак мангр тамырлар",
  "block.minecraft.mushroom_stem": "Гөмбә сабагы",
  "block.minecraft.mycelium": "Гөмбәлек",
  "block.minecraft.nether_brick_fence": "Незер кирпеч койма",
  "block.minecraft.nether_brick_slab": "Незер кирпеч плитә",
  "block.minecraft.nether_brick_stairs": "Незер кирпеч баскычлар",
  "block.minecraft.nether_brick_wall": "Незер кирпеч киртә",
  "block.minecraft.nether_bricks": "Незер кирпечләре",
  "block.minecraft.nether_gold_ore": "Незер-алтын мәгъдәне",
  "block.minecraft.nether_portal": "Незерга портал",
  "block.minecraft.nether_quartz_ore": "Незер-кварц мәгъдәне",
  "block.minecraft.nether_sprouts": "Незер үсентесе",
  "block.minecraft.nether_wart": "Незер үскене",
  "block.minecraft.nether_wart_block": "Незер үскене блогы",
  "block.minecraft.netherite_block": "Незерит блок",
  "block.minecraft.netherrack": "Незерәк",
  "block.minecraft.note_block": "Ноталар блогы",
  "block.minecraft.oak_button": "Имән төймә",
  "block.minecraft.oak_door": "Имән ишек",
  "block.minecraft.oak_fence": "Имән койма",
  "block.minecraft.oak_fence_gate": "Имән капка",
  "block.minecraft.oak_hanging_sign": "Элүле имән билге",
  "block.minecraft.oak_leaves": "Имән яфраклары",
  "block.minecraft.oak_log": "Имән бүрәнә",
  "block.minecraft.oak_planks": "Имән такталар",
  "block.minecraft.oak_pressure_plate": "Имән басма плитә",
  "block.minecraft.oak_sapling": "Имән үсентесе",
  "block.minecraft.oak_shelf": "Имән киштә",
  "block.minecraft.oak_sign": "Имән билге",
  "block.minecraft.oak_slab": "Имән плитә",
  "block.minecraft.oak_stairs": "Имән баскычлар",
  "block.minecraft.oak_trapdoor": "Имән люк",
  "block.minecraft.oak_wall_hanging_sign": "Элүле имән дивардагы билге",
  "block.minecraft.oak_wall_sign": "Имән дивардагы билге",
  "block.minecraft.oak_wood": "Имән",
  "block.minecraft.observer": "Күзәткеч",
  "block.minecraft.obsidian": "Обсидиан",
  "block.minecraft.ochre_froglight": "Охрсыман яктыбака",
  "block.minecraft.ominous_banner": "Дәһшәтле байрак",
  "block.minecraft.open_eyeblossom": "Ачык күзгөл",
  "block.minecraft.orange_banner": "Кызгылт сары байрак",
  "block.minecraft.orange_bed": "Кызгылт сары карават",
  "block.minecraft.orange_candle": "Кызгылт сары шәм",
  "block.minecraft.orange_candle_cake": "Кызгылт сары шәмле торт",
  "block.minecraft.orange_carpet": "Кызгылт сары келәм",
  "block.minecraft.orange_concrete": "Кызгылт сары бетон",
  "block.minecraft.orange_concrete_powder": "Кызгылт сары коры бетон",
  "block.minecraft.orange_glazed_terracotta": "Кызгылт сары глазурьланган керамика",
  "block.minecraft.orange_shulker_box": "Кызгылт сары шалкер тартмасы",
  "block.minecraft.orange_stained_glass": "Кызгылт сары пыяла",
  "block.minecraft.orange_stained_glass_pane": "Кызгылт сары бизәкле пыяла панель",
  "block.minecraft.orange_terracotta": "Кызгылт сары керамика",
  "block.minecraft.orange_tulip": "Кызгылт сары ләлә",
  "block.minecraft.orange_wool": "Кызгылт сары йон",
  "block.minecraft.oxeye_daisy": "Акбаш",
  "block.minecraft.oxidized_chiseled_copper": "Оксидланган уелган бакыр блок",
  "block.minecraft.oxidized_copper": "Оксидланган бакыр блок",
  "block.minecraft.oxidized_copper_bars": "Оксидланган бакыр рәшәткәләр",
  "block.minecraft.oxidized_copper_bulb": "Оксидланган бакыр лампа",
  "block.minecraft.oxidized_copper_chain": "Оксидланган бакыр чылбыр",
  "block.minecraft.oxidized_copper_chest": "Оксидланган бакыр сандык",
  "block.minecraft.oxidized_copper_door": "Оксидланган бакыр ишек",
  "block.minecraft.oxidized_copper_golem_statue": "Оксидланган бакыр голем сыны",
  "block.minecraft.oxidized_copper_grate": "Оксидланган бакыр рәшәткә",
  "block.minecraft.oxidized_copper_lantern": "Оксидланган бакыр фонарь",
  "block.minecraft.oxidized_copper_trapdoor": "Оксидланган бакыр люк",
  "block.minecraft.oxidized_cut_copper": "Оксидланган киселгән бакыр",
  "block.minecraft.oxidized_cut_copper_slab": "Оксидланган киселгән бакыр плитә",
  "block.minecraft.oxidized_cut_copper_stairs": "Оксидланган киселгән бакыр баскычлар",
  "block.minecraft.oxidized_lightning_rod": "Оксидланган яшен кайтаргыч",
  "block.minecraft.packed_ice": "Калын боз",
  "block.minecraft.packed_mud": "Саман",
  "block.minecraft.pale_hanging_moss": "Элүле тонык мүк",
  "block.minecraft.pale_moss_block": "Тонык мүк блогы",
  "block.minecraft.pale_moss_carpet": "Тонык мүк келәме",
  "block.minecraft.pale_oak_button": "Тонык имән төймә",
  "block.minecraft.pale_oak_door": "Тонык имән ишек",
  "block.minecraft.pale_oak_fence": "Тонык имән койма",
  "block.minecraft.pale_oak_fence_gate": "Тонык имән капка",
  "block.minecraft.pale_oak_hanging_sign": "Элүле тонык имән билге",
  "block.minecraft.pale_oak_leaves": "Тонык имән яфраклары",
  "block.minecraft.pale_oak_log": "Тонык имән бүрәнә",
  "block.minecraft.pale_oak_planks": "Тонык имән такталар",
  "block.minecraft.pale_oak_pressure_plate": "Тонык имән басма плитә",
  "block.minecraft.pale_oak_sapling": "Тонык имән үсентесе",
  "block.minecraft.pale_oak_shelf": "Тонык имән киштә",
  "block.minecraft.pale_oak_sign": "Тонык имән билге",
  "block.minecraft.pale_oak_slab": "Тонык имән плитә",
  "block.minecraft.pale_oak_stairs": "Тонык имән баскычлар",
  "block.minecraft.pale_oak_trapdoor": "Тонык имән люк",
  "block.minecraft.pale_oak_wall_hanging_sign": "Элүле тонык имән дивардагы билге",
  "block.minecraft.pale_oak_wall_sign": "Тонык имән дивардагы билге",
  "block.minecraft.pale_oak_wood": "Тонык имән",
  "block.minecraft.pearlescent_froglight": "Перламутр яктыбака",
  "block.minecraft.peony": "Чалма чәчәк",
  "block.minecraft.petrified_oak_slab": "Ташланган имән плитә",
  "block.minecraft.piglin_head": "Пиглин башы",
  "block.minecraft.piglin_wall_head": "Пиглин дивар башы",
  "block.minecraft.pink_banner": "Ал байрак",
  "block.minecraft.pink_bed": "Ал карават",
  "block.minecraft.pink_candle": "Ал шәм",
  "block.minecraft.pink_candle_cake": "Ал шәмле торт",
  "block.minecraft.pink_carpet": "Ал келәм",
  "block.minecraft.pink_concrete": "Ал бетон",
  "block.minecraft.pink_concrete_powder": "Ал коры бетон",
  "block.minecraft.pink_glazed_terracotta": "Ал глазурьланган керамика",
  "block.minecraft.pink_petals": "Ал аерчалары",
  "block.minecraft.pink_shulker_box": "Ал шалкер тартмасы",
  "block.minecraft.pink_stained_glass": "Ал пыяла",
  "block.minecraft.pink_stained_glass_pane": "Ал бизәкле пыяла панель",
  "block.minecraft.pink_terracotta": "Ал керамика",
  "block.minecraft.pink_tulip": "Ал ләлә",
  "block.minecraft.pink_wool": "Ал йон",
  "block.minecraft.piston": "Пешкәк",
  "block.minecraft.piston_head": "Пешкәк башчыгы",
  "block.minecraft.pitcher_crop": "Комганчы үсентесе",
  "block.minecraft.pitcher_plant": "Комганчы",
  "block.minecraft.player_head": "Уенчы башы",
  "block.minecraft.player_head.named": "%s башы",
  "block.minecraft.player_wall_head": "Стена уенчы башы",
  "block.minecraft.podzol": "Көлсу туфрак",
  "block.minecraft.pointed_dripstone": "Тамчыташ сөңгеләре",
  "block.minecraft.polished_andesite": "Шомартылган андезит",
  "block.minecraft.polished_andesite_slab": "Шомартылган андезит плитә",
  "block.minecraft.polished_andesite_stairs": "Шомартылган андезит баскычлар",
  "block.minecraft.polished_basalt": "Шомартылган базальт",
  "block.minecraft.polished_blackstone": "Шомартылган караташ",
  "block.minecraft.polished_blackstone_brick_slab": "Шомартылган караташ кирпеч плитә",
  "block.minecraft.polished_blackstone_brick_stairs": "Шомартылган караташ кирпеч баскычлар",
  "block.minecraft.polished_blackstone_brick_wall": "Шомартылган караташ кирпеч киртә",
  "block.minecraft.polished_blackstone_bricks": "Шомартылган караташ кирпечләр",
  "block.minecraft.polished_blackstone_button": "Шомартылган караташ төймә",
  "block.minecraft.polished_blackstone_pressure_plate": "Шомартылган караташ басма плитә",
  "block.minecraft.polished_blackstone_slab": "Шомартылган караташ плитә",
  "block.minecraft.polished_blackstone_stairs": "Шомартылган караташ баскычлар",
  "block.minecraft.polished_blackstone_wall": "Шомартылган караташ койма",
  "block.minecraft.polished_deepslate": "Шомартылган тирән сланец",
  "block.minecraft.polished_deepslate_slab": "Шомартылган тирән сланец плитә",
  "block.minecraft.polished_deepslate_stairs": "Шомартылган тирән сланец баскычлар",
  "block.minecraft.polished_deepslate_wall": "Шомартылган тирән сланец киртә",
  "block.minecraft.polished_diorite": "Шомартылган диорит",
  "block.minecraft.polished_diorite_slab": "Шомартылган диорит плитә",
  "block.minecraft.polished_diorite_stairs": "Шомартылган диорит баскычлар",
  "block.minecraft.polished_granite": "Шомартылган гранит",
  "block.minecraft.polished_granite_slab": "Шомартылган гранит плитә",
  "block.minecraft.polished_granite_stairs": "Шомартылган гранит баскычлар",
  "block.minecraft.polished_tuff": "Шомартылган туф",
  "block.minecraft.polished_tuff_slab": "Шомартылган туф плитә",
  "block.minecraft.polished_tuff_stairs": "Шомартылган туф баскычлар",
  "block.minecraft.polished_tuff_wall": "Шомартылган туф киртә",
  "block.minecraft.poppy": "Мәк",
  "block.minecraft.potatoes": "Бәрәңге",
  "block.minecraft.potted_acacia_sapling": "Утыртылган сәрви агач үсентесе",
  "block.minecraft.potted_allium": "Утыртылган сарымсак",
  "block.minecraft.potted_azalea_bush": "Утыртылган азалия",
  "block.minecraft.potted_azure_bluet": "Утыртылган зәңгәрсу күкбаш",
  "block.minecraft.potted_bamboo": "Утыртылган бамбук",
  "block.minecraft.potted_birch_sapling": "Утыртылган каен үсентесе",
  "block.minecraft.potted_blue_orchid": "Утыртылган зәңгәр күке яше",
  "block.minecraft.potted_brown_mushroom": "Утыртылган көрән гөмбә",
  "block.minecraft.potted_cactus": "Утыртылган кактус",
  "block.minecraft.potted_cherry_sapling": "Утыртылган чия",
  "block.minecraft.potted_closed_eyeblossom": "Утыртылган ябык күзгөл",
  "block.minecraft.potted_cornflower": "Утыртылган күкчәчәк",
  "block.minecraft.potted_crimson_fungus": "Утыртылган кырмызы гөмбә",
  "block.minecraft.potted_crimson_roots": "Утыртылган кырмызы тамырлар",
  "block.minecraft.potted_dandelion": "Утыртылган тузганак",
  "block.minecraft.potted_dark_oak_sapling": "Утыртылган кара имән үсентесе",
  "block.minecraft.potted_dead_bush": "Утыртылган үле куак",
  "block.minecraft.potted_fern": "Утыртылган абага",
  "block.minecraft.potted_flowering_azalea_bush": "Утыртылган чәчәк аткан азалия",
  "block.minecraft.potted_golden_dandelion": "Утыртылган алтын тузганак",
  "block.minecraft.potted_jungle_sapling": "Утыртылган тропик агач үсентесе",
  "block.minecraft.potted_lily_of_the_valley": "Утыртылган ландыш",
  "block.minecraft.potted_mangrove_propagule": "Утыртылган мангр сабы",
  "block.minecraft.potted_oak_sapling": "Утыртылган имән үсентесе",
  "block.minecraft.potted_open_eyeblossom": "Утыртылган ачык күзгөл",
  "block.minecraft.potted_orange_tulip": "Утыртылган кызгылт сары ләлә",
  "block.minecraft.potted_oxeye_daisy": "Утыртылган акбаш",
  "block.minecraft.potted_pale_oak_sapling": "Утыртылган тонык имән үсентесе",
  "block.minecraft.potted_pink_tulip": "Утыртылган ал ләлә",
  "block.minecraft.potted_poppy": "Утыртылган мәк",
  "block.minecraft.potted_red_mushroom": "Утыртылган кызыл гөмбә",
  "block.minecraft.potted_red_tulip": "Утыртылган кызыл ләлә",
  "block.minecraft.potted_spruce_sapling": "Утыртылган чыршы үсентесе",
  "block.minecraft.potted_torchflower": "Утыртылган факелгөл",
  "block.minecraft.potted_warped_fungus": "Утырылган гаҗәп гөмбә",
  "block.minecraft.potted_warped_roots": "Утыртылган гаҗәп тамырлар",
  "block.minecraft.potted_white_tulip": "Утыртылган ак ләлә",
  "block.minecraft.potted_wither_rose": "Утыртылган визер чәчәк",
  "block.minecraft.powder_snow": "Көпшәк кар",
  "block.minecraft.powder_snow_cauldron": "Көпшәк карлы казан",
  "block.minecraft.powered_rail": "Егәрле тимер юл",
  "block.minecraft.prismarine": "Призмарин",
  "block.minecraft.prismarine_brick_slab": "Призмарин кирпеч плитә",
  "block.minecraft.prismarine_brick_stairs": "Призмарин кирпеч баскычлар",
  "block.minecraft.prismarine_bricks": "Призмарин кирпечләр",
  "block.minecraft.prismarine_slab": "Призмарин плитә",
  "block.minecraft.prismarine_stairs": "Призмарин баскычлар",
  "block.minecraft.prismarine_wall": "Призмарин киртә",
  "block.minecraft.pumpkin": "Кабак",
  "block.minecraft.pumpkin_stem": "Кабак сабагы",
  "block.minecraft.purple_banner": "Шәмәхә байрак",
  "block.minecraft.purple_bed": "Шәмәхә карават",
  "block.minecraft.purple_candle": "Шәмәхә шәм",
  "block.minecraft.purple_candle_cake": "Шәмәхә шәмле торт",
  "block.minecraft.purple_carpet": "Шәмәхә келәм",
  "block.minecraft.purple_concrete": "Шәмәхә бетон",
  "block.minecraft.purple_concrete_powder": "Шәмәхә коры бетон",
  "block.minecraft.purple_glazed_terracotta": "Шәмәхә глазурьланган керамика",
  "block.minecraft.purple_shulker_box": "Шәмәхә шалкер тартмасы",
  "block.minecraft.purple_stained_glass": "Шәмәхә пыяла",
  "block.minecraft.purple_stained_glass_pane": "Шәмәхә бизәкле пыяла панель",
  "block.minecraft.purple_terracotta": "Шәмәхә керамика",
  "block.minecraft.purple_wool": "Шәмәхә йон",
  "block.minecraft.purpur_block": "Пурпур",
  "block.minecraft.purpur_pillar": "Пурпур багана",
  "block.minecraft.purpur_slab": "Пурпур плитә",
  "block.minecraft.purpur_stairs": "Пурпур баскычлар",
  "block.minecraft.quartz_block": "Кварц блок",
  "block.minecraft.quartz_bricks": "Кварц кирпечләр",
  "block.minecraft.quartz_pillar": "Кварц багана",
  "block.minecraft.quartz_slab": "Кварц плитә",
  "block.minecraft.quartz_stairs": "Кварц баскычлар",
  "block.minecraft.rail": "Тимер юл",
  "block.minecraft.raw_copper_block": "Мәгъдәнле бакыр блок",
  "block.minecraft.raw_gold_block": "Мәгъдәнле алтын блок",
  "block.minecraft.raw_iron_block": "Мәгъдәнле тимер блок",
  "block.minecraft.red_banner": "Кызыл байрак",
  "block.minecraft.red_bed": "Кызыл карават",
  "block.minecraft.red_candle": "Кызыл шәм",
  "block.minecraft.red_candle_cake": "Кызыл шәмле торт",
  "block.minecraft.red_carpet": "Кызыл келәм",
  "block.minecraft.red_concrete": "Кызыл бетон",
  "block.minecraft.red_concrete_powder": "Кызыл коры бетон",
  "block.minecraft.red_glazed_terracotta": "Кызыл глазурьланган керамика",
  "block.minecraft.red_mushroom": "Кызыл гөмбә",
  "block.minecraft.red_mushroom_block": "Кызыл гөмбә блогы",
  "block.minecraft.red_nether_brick_slab": "Кызыл незер кирпеч плитә",
  "block.minecraft.red_nether_brick_stairs": "Кызыл незер кирпеч баскычлар",
  "block.minecraft.red_nether_brick_wall": "Кызыл незер кирпеч киртә",
  "block.minecraft.red_nether_bricks": "Кызыл незер кирпече",
  "block.minecraft.red_sand": "Кызыл ком",
  "block.minecraft.red_sandstone": "Кызыл комташ",
  "block.minecraft.red_sandstone_slab": "Кызыл комташ плитә",
  "block.minecraft.red_sandstone_stairs": "Кызыл комташ баскычлар",
  "block.minecraft.red_sandstone_wall": "Кызыл комташ киртә",
  "block.minecraft.red_shulker_box": "Кызыл шалкер тартмасы",
  "block.minecraft.red_stained_glass": "Кызыл пыяла",
  "block.minecraft.red_stained_glass_pane": "Кызыл бизәкле пыяла панель",
  "block.minecraft.red_terracotta": "Кызыл керамика",
  "block.minecraft.red_tulip": "Кызыл ләлә",
  "block.minecraft.red_wool": "Кызыл йон",
  "block.minecraft.redstone_block": "Редстоун блок",
  "block.minecraft.redstone_lamp": "Редстоун лампа",
  "block.minecraft.redstone_ore": "Редстоун мәгъдәне",
  "block.minecraft.redstone_torch": "Редстоун факел",
  "block.minecraft.redstone_wall_torch": "Стена редстоун факел",
  "block.minecraft.redstone_wire": "Редстоун үткәргеч",
  "block.minecraft.reinforced_deepslate": "Ныгытылган тирән сланец",
  "block.minecraft.repeater": "Редстоун кабатлаткыч",
  "block.minecraft.repeating_command_block": "Кабатлаучы боерык блок",
  "block.minecraft.resin_block": "Сагыз блок",
  "block.minecraft.resin_brick_slab": "Сагыз кирпеч плитә",
  "block.minecraft.resin_brick_stairs": "Сагыз кирпеч баскычлар",
  "block.minecraft.resin_brick_wall": "Сагыз кирпеч киртә",
  "block.minecraft.resin_bricks": "Сагыз кирпечләр",
  "block.minecraft.resin_clump": "Сагыз төере",
  "block.minecraft.respawn_anchor": "Тергезү ләнгәре",
  "block.minecraft.rooted_dirt": "Тамырлы җир",
  "block.minecraft.rose_bush": "Гөлчәчәк куагы",
  "block.minecraft.sand": "Ком",
  "block.minecraft.sandstone": "Комташ",
  "block.minecraft.sandstone_slab": "Комташ плитә",
  "block.minecraft.sandstone_stairs": "Комташ баскычлар",
  "block.minecraft.sandstone_wall": "Комташ киртә",
  "block.minecraft.scaffolding": "Таскак",
  "block.minecraft.sculk": "Скалк",
  "block.minecraft.sculk_catalyst": "Скалк катализаторы",
  "block.minecraft.sculk_sensor": "Скалк сенсоры",
  "block.minecraft.sculk_shrieker": "Скалк кычкырткычы",
  "block.minecraft.sculk_vein": "Скалк тамырчыгы",
  "block.minecraft.sea_lantern": "Диңгез фонаре",
  "block.minecraft.sea_pickle": "Диңгез кыяры",
  "block.minecraft.seagrass": "Диңгез үләне",
  "block.minecraft.set_spawn": "Тергезү ноктасы урнаштырылды",
  "block.minecraft.short_dry_grass": "Кыска коры үлән",
  "block.minecraft.short_grass": "Кыска үлән",
  "block.minecraft.shroomlight": "Яктыгөмбә",
  "block.minecraft.shulker_box": "Шалкер тартмасы",
  "block.minecraft.skeleton_skull": "Скелет башы",
  "block.minecraft.skeleton_wall_skull": "Стена скелет башы",
  "block.minecraft.slime_block": "Лайла блогы",
  "block.minecraft.small_amethyst_bud": "Кечкенә аметист бәйләме",
  "block.minecraft.small_dripleaf": "Кечкенә тамчы яфрак",
  "block.minecraft.smithing_table": "Тимерче өстәле",
  "block.minecraft.smoker": "Ыслаткыч",
  "block.minecraft.smooth_basalt": "Тигез базальт",
  "block.minecraft.smooth_quartz": "Тигез кварц блок",
  "block.minecraft.smooth_quartz_slab": "Тигез кварц плитә",
  "block.minecraft.smooth_quartz_stairs": "Тигез кварц баскычлар",
  "block.minecraft.smooth_red_sandstone": "Тигез кызыл комташ",
  "block.minecraft.smooth_red_sandstone_slab": "Тигез кызыл комташ плитә",
  "block.minecraft.smooth_red_sandstone_stairs": "Тигез кызыл комташ баскычлар",
  "block.minecraft.smooth_sandstone": "Тигез комташ",
  "block.minecraft.smooth_sandstone_slab": "Тигез комташ плитә",
  "block.minecraft.smooth_sandstone_stairs": "Тигез комташ баскычлар",
  "block.minecraft.smooth_stone": "Тигез таш",
  "block.minecraft.smooth_stone_slab": "Тигез таш плитә",
  "block.minecraft.sniffer_egg": "Иснәүче йомыркасы",
  "block.minecraft.snow": "Кар",
  "block.minecraft.snow_block": "Кар блок",
  "block.minecraft.soul_campfire": "Җан учагы",
  "block.minecraft.soul_fire": "Җан уты",
  "block.minecraft.soul_lantern": "Җан фонаре",
  "block.minecraft.soul_sand": "Җан комы",
  "block.minecraft.soul_soil": "Җан туфрагы",
  "block.minecraft.soul_torch": "Җан факелы",
  "block.minecraft.soul_wall_torch": "Стена җан факелы",
  "block.minecraft.spawn.not_valid": "Сездә карават яки корылган тергезү ләнгәре юк, яки алар кыен урында",
  "block.minecraft.spawner": "Үрентелек",
  "block.minecraft.spawner.desc1": "Чакыру йомыркасы белән эш ителгәндә:",
  "block.minecraft.spawner.desc2": "Моб төрен билгели",
  "block.minecraft.sponge": "Болыт",
  "block.minecraft.spore_blossom": "Спора гөле",
  "block.minecraft.spruce_button": "Чыршы төймә",
  "block.minecraft.spruce_door": "Чыршы ишек",
  "block.minecraft.spruce_fence": "Чыршы койма",
  "block.minecraft.spruce_fence_gate": "Чыршы капка",
  "block.minecraft.spruce_hanging_sign": "Элүле чыршы билге",
  "block.minecraft.spruce_leaves": "Чыршы ылысы",
  "block.minecraft.spruce_log": "Чыршы бүрәнә",
  "block.minecraft.spruce_planks": "Чыршы такталар",
  "block.minecraft.spruce_pressure_plate": "Чыршы басма плитә",
  "block.minecraft.spruce_sapling": "Чыршы үсентесе",
  "block.minecraft.spruce_shelf": "Чыршы киштә",
  "block.minecraft.spruce_sign": "Чыршы билге",
  "block.minecraft.spruce_slab": "Чыршы плитә",
  "block.minecraft.spruce_stairs": "Чыршы баскычлар",
  "block.minecraft.spruce_trapdoor": "Чыршы люк",
  "block.minecraft.spruce_wall_hanging_sign": "Элүле чыршы дивардагы билге",
  "block.minecraft.spruce_wall_sign": "Чыршы дивардагы билге",
  "block.minecraft.spruce_wood": "Чыршы",
  "block.minecraft.sticky_piston": "Ябышкак пешкәк",
  "block.minecraft.stone": "Таш",
  "block.minecraft.stone_brick_slab": "Таш кирпеч плитә",
  "block.minecraft.stone_brick_stairs": "Таш кирпеч баскычлар",
  "block.minecraft.stone_brick_wall": "Таш кирпеч киртә",
  "block.minecraft.stone_bricks": "Таш кирпечләр",
  "block.minecraft.stone_button": "Таш төймә",
  "block.minecraft.stone_pressure_plate": "Таш басма плитә",
  "block.minecraft.stone_slab": "Таш плитә",
  "block.minecraft.stone_stairs": "Таш баскычлар",
  "block.minecraft.stonecutter": "Ташкискеч",
  "block.minecraft.stripped_acacia_log": "Юнылган сәрви бүрәнә",
  "block.minecraft.stripped_acacia_wood": "Юнылган сәрви",
  "block.minecraft.stripped_bamboo_block": "Юнылган бамбук блок",
  "block.minecraft.stripped_birch_log": "Юнылган каен бүрәнә",
  "block.minecraft.stripped_birch_wood": "Юнылган каен",
  "block.minecraft.stripped_cherry_log": "Юнылган чия бүрәнә",
  "block.minecraft.stripped_cherry_wood": "Юнылган чия",
  "block.minecraft.stripped_crimson_hyphae": "Юнылган кырмызы җепселләре",
  "block.minecraft.stripped_crimson_stem": "Юнылган кырмызы сабак",
  "block.minecraft.stripped_dark_oak_log": "Юнылган кара имән бүрәнә",
  "block.minecraft.stripped_dark_oak_wood": "Юнылган кара имән",
  "block.minecraft.stripped_jungle_log": "Юнылган тропик агач бүрәнә",
  "block.minecraft.stripped_jungle_wood": "Юнылган тропик агач",
  "block.minecraft.stripped_mangrove_log": "Шәрә мангр бүрәнә",
  "block.minecraft.stripped_mangrove_wood": "Юнылган мангр",
  "block.minecraft.stripped_oak_log": "Юнылган имән бүрәнә",
  "block.minecraft.stripped_oak_wood": "Юнылган имән",
  "block.minecraft.stripped_pale_oak_log": "Юнылган тонык имән бүрәнә",
  "block.minecraft.stripped_pale_oak_wood": "Юнылган тонык имән",
  "block.minecraft.stripped_spruce_log": "Юнылган чыршы бүрәнә",
  "block.minecraft.stripped_spruce_wood": "Юнылган чыршы",
  "block.minecraft.stripped_warped_hyphae": "Юнылган гаҗәп җепселләре",
  "block.minecraft.stripped_warped_stem": "Юнылган гаҗәп сабак",
  "block.minecraft.structure_block": "Корылма блогы",
  "block.minecraft.structure_void": "Буш блок",
  "block.minecraft.sugar_cane": "Шикәр камышы",
  "block.minecraft.sunflower": "Көнбагыш",
  "block.minecraft.suspicious_gravel": "Шикле чуерташ",
  "block.minecraft.suspicious_sand": "Шикле ком",
  "block.minecraft.sweet_berry_bush": "Баллы җиләк куагы",
  "block.minecraft.tall_dry_grass": "Озын коры үлән",
  "block.minecraft.tall_grass": "Озын үлән",
  "block.minecraft.tall_seagrass": "Озын диңгез үләне",
  "block.minecraft.target": "Мишень",
  "block.minecraft.terracotta": "Керамика",
  "block.minecraft.test_block": "Тест блогы",
  "block.minecraft.test_instance_block": "Тест нөсхәсе блогы",
  "block.minecraft.tinted_glass": "Караңгыланган пыяла",
  "block.minecraft.tnt": "Динамит",
  "block.minecraft.tnt.disabled": "Динамит шартлаулар сүнек",
  "block.minecraft.torch": "Факел",
  "block.minecraft.torchflower": "Факелгөл",
  "block.minecraft.torchflower_crop": "Факелгөл үсентесе",
  "block.minecraft.trapped_chest": "Капкын сандык",
  "block.minecraft.trial_spawner": "Сынау үрентелеге",
  "block.minecraft.tripwire": "Кыл",
  "block.minecraft.tripwire_hook": "Ыргак",
  "block.minecraft.tube_coral": "Торбасыман мәрҗән",
  "block.minecraft.tube_coral_block": "Торбасыман мәрҗән блогы",
  "block.minecraft.tube_coral_fan": "Җилпәзә торбасыман мәрҗән",
  "block.minecraft.tube_coral_wall_fan": "Җилпәзә ятма торбасыман мәрҗән",
  "block.minecraft.tuff": "Туф",
  "block.minecraft.tuff_brick_slab": "Туф кирпеч плитә",
  "block.minecraft.tuff_brick_stairs": "Туф кирпеч баскычлар",
  "block.minecraft.tuff_brick_wall": "Туф кирпеч киртә",
  "block.minecraft.tuff_bricks": "Туф кирпечләр",
  "block.minecraft.tuff_slab": "Туф плитә",
  "block.minecraft.tuff_stairs": "Туф баскычлар",
  "block.minecraft.tuff_wall": "Туф киртә",
  "block.minecraft.turtle_egg": "Ташбака йомыркасы",
  "block.minecraft.twisting_vines": "Үреленгән чыбык",
  "block.minecraft.twisting_vines_plant": "Үреленгән чыбык сабагы",
  "block.minecraft.vault": "Саклагыч",
  "block.minecraft.verdant_froglight": "Малахит яктыбака",
  "block.minecraft.vine": "Лианалар",
  "block.minecraft.void_air": "Вакуум",
  "block.minecraft.wall_torch": "Стена факел",
  "block.minecraft.warped_button": "Гаҗәп төймә",
  "block.minecraft.warped_door": "Гаҗәп ишек",
  "block.minecraft.warped_fence": "Гаҗәп койма",
  "block.minecraft.warped_fence_gate": "Гаҗәп капка",
  "block.minecraft.warped_fungus": "Гаҗәп гөмбә",
  "block.minecraft.warped_hanging_sign": "Элүле гаҗәп билге",
  "block.minecraft.warped_hyphae": "Гаҗәп җепселләре",
  "block.minecraft.warped_nylium": "Гаҗәп нәлек",
  "block.minecraft.warped_planks": "Гаҗәп такталар",
  "block.minecraft.warped_pressure_plate": "Гаҗәп басма плитә",
  "block.minecraft.warped_roots": "Гаҗәп тамырлар",
  "block.minecraft.warped_shelf": "Гаҗәп киштә",
  "block.minecraft.warped_sign": "Гаҗәп билге",
  "block.minecraft.warped_slab": "Гаҗәп плитә",
  "block.minecraft.warped_stairs": "Гаҗәп баскычлар",
  "block.minecraft.warped_stem": "Гаҗәп сабак",
  "block.minecraft.warped_trapdoor": "Гаҗәп люк",
  "block.minecraft.warped_wall_hanging_sign": "Элүле гаҗәп дивардагы билге",
  "block.minecraft.warped_wall_sign": "Гаҗәп дивардагы билге",
  "block.minecraft.warped_wart_block": "Гаҗәп үскене блогы",
  "block.minecraft.water": "Су",
  "block.minecraft.water_cauldron": "Сулы казан",
  "block.minecraft.waxed_chiseled_copper": "Балавызлы уелган бакыр блок",
  "block.minecraft.waxed_copper_bars": "Балавызлы бакыр рәшәткәләр",
  "block.minecraft.waxed_copper_block": "Балавызлы бакыр блок",
  "block.minecraft.waxed_copper_bulb": "Балавызлы бакыр лампа",
  "block.minecraft.waxed_copper_chain": "Балавызлы бакыр чылбыр",
  "block.minecraft.waxed_copper_chest": "Балавызлы бакыр сандык",
  "block.minecraft.waxed_copper_door": "Балавызлы бакыр ишек",
  "block.minecraft.waxed_copper_golem_statue": "Балавызлы бакыр голем сыны",
  "block.minecraft.waxed_copper_grate": "Балавызлы бакыр рәшәткә",
  "block.minecraft.waxed_copper_lantern": "Балавызлы бакыр фонарь",
  "block.minecraft.waxed_copper_trapdoor": "Балавызлы бакыр люк",
  "block.minecraft.waxed_cut_copper": "Балавызлы киселгән бакыр",
  "block.minecraft.waxed_cut_copper_slab": "Балавызлы киселгән бакыр плитә",
  "block.minecraft.waxed_cut_copper_stairs": "Балавызлы киселгән бакыр баскычлар",
  "block.minecraft.waxed_exposed_chiseled_copper": "Балавызлы караланган уелган бакыр блок",
  "block.minecraft.waxed_exposed_copper": "Караланган балавызлы бакыр",
  "block.minecraft.waxed_exposed_copper_bars": "Балавызлы караланган бакыр рәшәткәләр",
  "block.minecraft.waxed_exposed_copper_bulb": "Балавызлы караланган бакыр лампа",
  "block.minecraft.waxed_exposed_copper_chain": "Балавызлы караланган бакыр чылбыр ",
  "block.minecraft.waxed_exposed_copper_chest": "Балавызлы караланган бакыр сандык",
  "block.minecraft.waxed_exposed_copper_door": "Балавызлы караланган бакыр ишек",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Балавызлы караланган бакыр голем сыны",
  "block.minecraft.waxed_exposed_copper_grate": "Балавызлы караланган бакыр рәшәткә",
  "block.minecraft.waxed_exposed_copper_lantern": "Балавызлы караланган бакыр фонарь",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Балавызлы караланган бакыр люк",
  "block.minecraft.waxed_exposed_cut_copper": "Балавызлы караланган киселгән бакыр",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Балавызлы караңгыланган киселгән бакыр плитә",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Балавызлы караланган киселгән бакыр баскычлар",
  "block.minecraft.waxed_exposed_lightning_rod": "Балавызлы караланган яшен кайтаргыч ",
  "block.minecraft.waxed_lightning_rod": "Балавызлы яшен кайтаргыч",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Балавызлы оксидланган уелган бакыр блок",
  "block.minecraft.waxed_oxidized_copper": "Оксидланган балавызлы бакыр блок",
  "block.minecraft.waxed_oxidized_copper_bars": "Балавызлы оксидланган бакыр рәшәткәләр",
  "block.minecraft.waxed_oxidized_copper_bulb": "Балавызлы оксидланган бакыр лампа",
  "block.minecraft.waxed_oxidized_copper_chain": "Балавызлы оксидланган бакыр чылбыр ",
  "block.minecraft.waxed_oxidized_copper_chest": "Балавызлы оксидланган бакыр сандык ",
  "block.minecraft.waxed_oxidized_copper_door": "Балавызлы оксидланган бакыр ишек",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Балавызлы оксидланган бакыр голем сыны",
  "block.minecraft.waxed_oxidized_copper_grate": "Балавызлы оксидланган бакыр рәшәткә",
  "block.minecraft.waxed_oxidized_copper_lantern": "Балавызлы оксидланган бакыр фонарь",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Балавызлы оксидланган бакыр люк",
  "block.minecraft.waxed_oxidized_cut_copper": "Балавызлы оксидланган киселгән бакыр",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Балавызлы оксидланган киселгән бакыр плитә",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Балавызлы оксидланган киселгән бакыр баскычлар",
  "block.minecraft.waxed_oxidized_lightning_rod": "Балавызлы оксидланган яшен кайтаргыч ",
  "block.minecraft.waxed_weathered_chiseled_copper": "Балавызлы искергән уелган бакыр блок",
  "block.minecraft.waxed_weathered_copper": "Искергән балавызлы бакыр",
  "block.minecraft.waxed_weathered_copper_bars": "Балавызлы искергән бакыр рәшәткәләр",
  "block.minecraft.waxed_weathered_copper_bulb": "Балавызлы искергән бакыр лампа",
  "block.minecraft.waxed_weathered_copper_chain": "Балавызлы искергән бакыр чылбыр",
  "block.minecraft.waxed_weathered_copper_chest": "Балавызлы искергән бакыр сандык ",
  "block.minecraft.waxed_weathered_copper_door": "Балавызлы искергән бакыр ишек",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Балавызлы искергән бакыр голем сыны",
  "block.minecraft.waxed_weathered_copper_grate": "Балавызлы искергән бакыр рәшәткә",
  "block.minecraft.waxed_weathered_copper_lantern": "Балавызлы искергән бакыр фонарь",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Балавызлы искергән бакыр люк",
  "block.minecraft.waxed_weathered_cut_copper": "Балавызлы искергән киселгән бакыр",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Балавызлы искергән киселгән бакыр плитә",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Балавызлы искергән киселгән бакыр баскычлар",
  "block.minecraft.waxed_weathered_lightning_rod": "Балавызлы искергән яшен кайтаргыч",
  "block.minecraft.weathered_chiseled_copper": "Искергән уелган бакыр блок",
  "block.minecraft.weathered_copper": "Искергән бакыр блок",
  "block.minecraft.weathered_copper_bars": "Искергән бакыр рәшәткәләр ",
  "block.minecraft.weathered_copper_bulb": "Искергән бакыр лампа",
  "block.minecraft.weathered_copper_chain": "Искергән бакыр чылбыр",
  "block.minecraft.weathered_copper_chest": "Искергән бакыр сандык",
  "block.minecraft.weathered_copper_door": "Искергән бакыр ишек",
  "block.minecraft.weathered_copper_golem_statue": "Искергән бакыр голем сыны",
  "block.minecraft.weathered_copper_grate": "Искергән бакыр рәшәткә",
  "block.minecraft.weathered_copper_lantern": "Искергән бакыр фонарь",
  "block.minecraft.weathered_copper_trapdoor": "Искергән бакыр люк",
  "block.minecraft.weathered_cut_copper": "Искергән киселгән бакыр",
  "block.minecraft.weathered_cut_copper_slab": "Искергән киселгән бакыр плитә",
  "block.minecraft.weathered_cut_copper_stairs": "Искергән киселгән бакыр баскычлар",
  "block.minecraft.weathered_lightning_rod": "Искергән яшен кайтаргыч",
  "block.minecraft.weeping_vines": "Бөдрә чыбык",
  "block.minecraft.weeping_vines_plant": "Бөдрә чыбык сабагы",
  "block.minecraft.wet_sponge": "Юеш болыт",
  "block.minecraft.wheat": "Бодай үсентеләре",
  "block.minecraft.white_banner": "Ак байрак",
  "block.minecraft.white_bed": "Ак карават",
  "block.minecraft.white_candle": "Ак шәм",
  "block.minecraft.white_candle_cake": "Ак шәмле торт",
  "block.minecraft.white_carpet": "Ак келәм",
  "block.minecraft.white_concrete": "Ак бетон",
  "block.minecraft.white_concrete_powder": "Ак коры бетон",
  "block.minecraft.white_glazed_terracotta": "Ак глазурьланган керамика",
  "block.minecraft.white_shulker_box": "Ак шалкер тартмасы",
  "block.minecraft.white_stained_glass": "Ак пыяла",
  "block.minecraft.white_stained_glass_pane": "Ак бизәкле пыяла панель",
  "block.minecraft.white_terracotta": "Ак керамика",
  "block.minecraft.white_tulip": "Ак ләлә",
  "block.minecraft.white_wool": "Ак йон",
  "block.minecraft.wildflowers": "Кыр чәчәкләре",
  "block.minecraft.wither_rose": "Визер гөлчәчәге",
  "block.minecraft.wither_skeleton_skull": "Визер-скелет башы",
  "block.minecraft.wither_skeleton_wall_skull": "Стена визер-скелет башы",
  "block.minecraft.yellow_banner": "Сары байрак",
  "block.minecraft.yellow_bed": "Сары карават",
  "block.minecraft.yellow_candle": "Сары шәм",
  "block.minecraft.yellow_candle_cake": "Сары шәмле торт",
  "block.minecraft.yellow_carpet": "Сары келәм",
  "block.minecraft.yellow_concrete": "Сары бетон",
  "block.minecraft.yellow_concrete_powder": "Сары коры бетон",
  "block.minecraft.yellow_glazed_terracotta": "Сары глазурьланган керамика",
  "block.minecraft.yellow_shulker_box": "Сары шалкер тартмасы",
  "block.minecraft.yellow_stained_glass": "Сары пыяла",
  "block.minecraft.yellow_stained_glass_pane": "Сары бизәкле пыяла панель",
  "block.minecraft.yellow_terracotta": "Сары керамика",
  "block.minecraft.yellow_wool": "Сары йон",
  "block.minecraft.zombie_head": "Зомби башы",
  "block.minecraft.zombie_wall_head": "Стена зомби башы",
  "item.minecraft.acacia_boat": "Сәрви көймә",
  "item.minecraft.acacia_chest_boat": "Сандыклы сәрви агач көймә",
  "item.minecraft.allay_spawn_egg": "Мыштыр чакыру йомыркасы",
  "item.minecraft.amethyst_shard": "Аметист кисәге",
  "item.minecraft.angler_pottery_shard": "«Балыкчы» чүлмәк ватыгы",
  "item.minecraft.angler_pottery_sherd": "«Балыкчы» чүлмәк ватыгы",
  "item.minecraft.apple": "Алма",
  "item.minecraft.archer_pottery_shard": "«Җәяче» чүлмәк ватыгы",
  "item.minecraft.archer_pottery_sherd": "«Җәяче» чүлмәк ватыгы",
  "item.minecraft.armadillo_scute": "Калканлы калканчыгы",
  "item.minecraft.armadillo_spawn_egg": "Калканлы чакыру йомыркасы",
  "item.minecraft.armor_stand": "Элгеч",
  "item.minecraft.arms_up_pottery_shard": "«Өскә күтәрелгән куллар» чүлмәк ватыгы",
  "item.minecraft.arms_up_pottery_sherd": "«Өскә күтәрелгән куллар» чүлмәк ватыгы",
  "item.minecraft.arrow": "Ук",
  "item.minecraft.axolotl_bucket": "Аксолотль чиләге",
  "item.minecraft.axolotl_spawn_egg": "Аксолотль чакыру йомыркасы",
  "item.minecraft.baked_potato": "Пешкән бәрәңге",
  "item.minecraft.bamboo_chest_raft": "Сандыклы бамбук сал",
  "item.minecraft.bamboo_raft": "Бамбук сал",
  "item.minecraft.bat_spawn_egg": "Ярканат чакыру йомыркасы",
  "item.minecraft.bee_spawn_egg": "Корт чакыру йомыркасы",
  "item.minecraft.beef": "Чи сыер ите",
  "item.minecraft.beetroot": "Чөгендер",
  "item.minecraft.beetroot_seeds": "Чөгендер орлыгы",
  "item.minecraft.beetroot_soup": "Чөгендер ашы",
  "item.minecraft.birch_boat": "Каен көймә",
  "item.minecraft.birch_chest_boat": "Сандыклы каен көймә",
  "item.minecraft.black_bundle": "Кара капчык",
  "item.minecraft.black_dye": "Кара буяу",
  "item.minecraft.black_harness": "Кара җигем",
  "item.minecraft.blade_pottery_shard": "«Йөз» чүлмәк ватыгы",
  "item.minecraft.blade_pottery_sherd": "«Йөз» чүлмәк ватыгы",
  "item.minecraft.blaze_powder": "Ялкынлы онтак",
  "item.minecraft.blaze_rod": "Ялкынлы таяк",
  "item.minecraft.blaze_spawn_egg": "Гыйфрит чакыру йомыркасы",
  "item.minecraft.blue_bundle": "Зәңгәр капчык",
  "item.minecraft.blue_dye": "Зәңгәр буяу",
  "item.minecraft.blue_egg": "Зәңгәр йомырка",
  "item.minecraft.blue_harness": "Зәңгәр җигем",
  "item.minecraft.bogged_spawn_egg": "Пычрагак чакыру йомыркасы",
  "item.minecraft.bolt_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "«Күчәр» бизәге",
  "item.minecraft.bone": "Сөяк",
  "item.minecraft.bone_meal": "Сөяк оны",
  "item.minecraft.book": "Китап",
  "item.minecraft.bordure_indented_banner_pattern": "«Тешле кайма» байрак бизәге",
  "item.minecraft.bow": "Җәя",
  "item.minecraft.bowl": "Тәлинкә",
  "item.minecraft.bread": "Икмәк",
  "item.minecraft.breeze_rod": "Җилле таяк",
  "item.minecraft.breeze_spawn_egg": "Җилчек чакыру йомыркасы",
  "item.minecraft.brewer_pottery_shard": "«Кайнатучы» чүлмәк ватыгы",
  "item.minecraft.brewer_pottery_sherd": "«Кайнатучы» чүлмәк ватыгы",
  "item.minecraft.brewing_stand": "Кайнаткыч",
  "item.minecraft.brick": "Кирпеч",
  "item.minecraft.brown_bundle": "Көрән капчык",
  "item.minecraft.brown_dye": "Көрән буяу",
  "item.minecraft.brown_egg": "Көрән йомырка",
  "item.minecraft.brown_harness": "Көрән җигем",
  "item.minecraft.brush": "Пумала",
  "item.minecraft.bucket": "Чиләк",
  "item.minecraft.bundle": "Капчык",
  "item.minecraft.bundle.empty": "Буш",
  "item.minecraft.bundle.empty.description": "Төрле предмет өемен сыйдыра ала",
  "item.minecraft.bundle.full": "Тулы",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "«Яну» чүлмәк ватыгы",
  "item.minecraft.burn_pottery_sherd": "«Яну» чүлмәк ватыгы",
  "item.minecraft.camel_husk_spawn_egg": "Дөя-үлек чакыру йомыркасы",
  "item.minecraft.camel_spawn_egg": "Дөя чакыру йомыркасы",
  "item.minecraft.carrot": "Кишер",
  "item.minecraft.carrot_on_a_stick": "Кишерле кармак",
  "item.minecraft.cat_spawn_egg": "Мәче чакыру йомыркасы",
  "item.minecraft.cauldron": "Казан",
  "item.minecraft.cave_spider_spawn_egg": "Мәгарә үрмәкүче чакыру йомыркасы",
  "item.minecraft.chainmail_boots": "Көбә итек",
  "item.minecraft.chainmail_chestplate": "Көбә күкрәкчә",
  "item.minecraft.chainmail_helmet": "Көбә башлык",
  "item.minecraft.chainmail_leggings": "Көбә ыштан",
  "item.minecraft.charcoal": "Агач күмер",
  "item.minecraft.cherry_boat": "Чия көймә",
  "item.minecraft.cherry_chest_boat": "Сандыклы чия көймә",
  "item.minecraft.chest_minecart": "Сандыклы арбачык",
  "item.minecraft.chicken": "Чи тавык ите",
  "item.minecraft.chicken_spawn_egg": "Тавык чакыру йомыркасы",
  "item.minecraft.chorus_fruit": "Хорус җимеше",
  "item.minecraft.clay_ball": "Балчык кисәге",
  "item.minecraft.clock": "Сәгать",
  "item.minecraft.coal": "Күмер",
  "item.minecraft.coast_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.coast_armor_trim_smithing_template.new": "«Яр» бизәге",
  "item.minecraft.cocoa_beans": "Какао-борчаклары",
  "item.minecraft.cod": "Чи тәрәч",
  "item.minecraft.cod_bucket": "Тәрәч чиләге",
  "item.minecraft.cod_spawn_egg": "Тәрәч чакыру йомыркасы",
  "item.minecraft.command_block_minecart": "Боерык блоклы арбачык",
  "item.minecraft.compass": "Компас",
  "item.minecraft.cooked_beef": "Кыздырган сыер ите",
  "item.minecraft.cooked_chicken": "Кыздырган тавык",
  "item.minecraft.cooked_cod": "Кыздырган тәрәч",
  "item.minecraft.cooked_mutton": "Кыздырган бәрән ите",
  "item.minecraft.cooked_porkchop": "Кыздырган дуңгыз ите",
  "item.minecraft.cooked_rabbit": "Кыздырган куян ите",
  "item.minecraft.cooked_salmon": "Кыздырган сөләйман",
  "item.minecraft.cookie": "Печенье",
  "item.minecraft.copper_axe": "Бакыр балта",
  "item.minecraft.copper_boots": "Бакыр итек",
  "item.minecraft.copper_chestplate": "Бакыр күкрәкчә",
  "item.minecraft.copper_golem_spawn_egg": "Бакыр голем чакыру йомыркасы",
  "item.minecraft.copper_helmet": "Бакыр башлык",
  "item.minecraft.copper_hoe": "Бакыр китмән",
  "item.minecraft.copper_horse_armor": "Бакыр ат көбәсе",
  "item.minecraft.copper_ingot": "Бакыр коелма",
  "item.minecraft.copper_leggings": "Бакыр ыштан",
  "item.minecraft.copper_nautilus_armor": "Бакыр наутилус көбәсе",
  "item.minecraft.copper_nugget": "Бакыр кисәге",
  "item.minecraft.copper_pickaxe": "Бакыр көйлә",
  "item.minecraft.copper_shovel": "Бакыр көрәк",
  "item.minecraft.copper_spear": "Бакыр сөңге",
  "item.minecraft.copper_sword": "Бакыр кылыч",
  "item.minecraft.cow_spawn_egg": "Сыер чакыру йомыркасы",
  "item.minecraft.creaking_spawn_egg": "Шакылдаучы чакыру йомыркасы",
  "item.minecraft.creeper_banner_pattern": "Байрак бизәге",
  "item.minecraft.creeper_banner_pattern.desc": "Крипер",
  "item.minecraft.creeper_banner_pattern.new": "«Крипер» байрак бизәге",
  "item.minecraft.creeper_spawn_egg": "Крипер чакыру йомыркасы",
  "item.minecraft.crossbow": "Арбалет",
  "item.minecraft.crossbow.projectile": "Җайланма:",
  "item.minecraft.crossbow.projectile.multiple": "Җайланма: ×%s %s",
  "item.minecraft.crossbow.projectile.single": "Җайланма: %s",
  "item.minecraft.cyan_bundle": "Фирәзә капчык",
  "item.minecraft.cyan_dye": "Фирәзә буяу",
  "item.minecraft.cyan_harness": "Фирәзә җигем",
  "item.minecraft.danger_pottery_shard": "«Куркынычлык» чүлмәк ватыгы",
  "item.minecraft.danger_pottery_sherd": "«Куркынычлык» чүлмәк ватыгы",
  "item.minecraft.dark_oak_boat": "Кара имән көймә",
  "item.minecraft.dark_oak_chest_boat": "Сандыклы кара имән көймә",
  "item.minecraft.debug_stick": "Төзәтү таягы",
  "item.minecraft.debug_stick.empty": "%s үзлексез",
  "item.minecraft.debug_stick.select": "«%s» (%s) сайланган",
  "item.minecraft.debug_stick.update": "«%s»: %s",
  "item.minecraft.diamond": "Алмаз",
  "item.minecraft.diamond_axe": "Алмаз балта",
  "item.minecraft.diamond_boots": "Алмаз итек",
  "item.minecraft.diamond_chestplate": "Алмаз күкрәкчә",
  "item.minecraft.diamond_helmet": "Алмаз башлык",
  "item.minecraft.diamond_hoe": "Алмаз китмән",
  "item.minecraft.diamond_horse_armor": "Алмаз ат көбәсе",
  "item.minecraft.diamond_leggings": "Алмаз ыштан",
  "item.minecraft.diamond_nautilus_armor": "Алмаз наутилус көбәсе",
  "item.minecraft.diamond_pickaxe": "Алмаз кәйлә",
  "item.minecraft.diamond_shovel": "Алмаз көрәк",
  "item.minecraft.diamond_spear": "Алмаз сөңге",
  "item.minecraft.diamond_sword": "Алмаз кылыч",
  "item.minecraft.disc_fragment_5": "Пластинка ватыгы",
  "item.minecraft.disc_fragment_5.desc": "Пластинка — 5",
  "item.minecraft.dolphin_spawn_egg": "Дельфин чакыру йомыркасы",
  "item.minecraft.donkey_spawn_egg": "Ишәк чакыру йомыркасы",
  "item.minecraft.dragon_breath": "Аҗдаһа сулышы",
  "item.minecraft.dried_kelp": "Кипкән суүсем",
  "item.minecraft.drowned_spawn_egg": "Батказ чакыру йомыркасы",
  "item.minecraft.dune_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.dune_armor_trim_smithing_template.new": "«Дюна» бизәге",
  "item.minecraft.echo_shard": "Кайтаваз ватыгы",
  "item.minecraft.egg": "Йомырка",
  "item.minecraft.elder_guardian_spawn_egg": "Борынгы каравылчы чакыру йомыркасы",
  "item.minecraft.elytra": "Элитра",
  "item.minecraft.emerald": "Зөбәрҗәт",
  "item.minecraft.enchanted_book": "Сихри китап",
  "item.minecraft.enchanted_golden_apple": "Сихерләнгән алтын алма",
  "item.minecraft.end_crystal": "Энд кристаллы",
  "item.minecraft.ender_dragon_spawn_egg": "Эндер-аждаһа чакыру йомыркасы",
  "item.minecraft.ender_eye": "Эндер-күз",
  "item.minecraft.ender_pearl": "Эндер-энҗе",
  "item.minecraft.enderman_spawn_egg": "Эндермән чакыру йомыркасы",
  "item.minecraft.endermite_spawn_egg": "Эндермит чакыру йомыркасы",
  "item.minecraft.evoker_spawn_egg": "Төфсенләүче чакыру йомыркасы",
  "item.minecraft.experience_bottle": "Тәҗрибә шешәсе",
  "item.minecraft.explorer_pottery_shard": "«Тикшерүче» чүлмәк ватыгы",
  "item.minecraft.explorer_pottery_sherd": "«Тикшерүче» чүлмәк ватыгы",
  "item.minecraft.eye_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.eye_armor_trim_smithing_template.new": "«Күз» бизәге",
  "item.minecraft.feather": "Каурый",
  "item.minecraft.fermented_spider_eye": "Маринадланган үрмәкүч күзе",
  "item.minecraft.field_masoned_banner_pattern": "«Каплама» байрак бизәге",
  "item.minecraft.filled_map": "Харита",
  "item.minecraft.fire_charge": "Ут корылмасы",
  "item.minecraft.firework_rocket": "Фейерверк",
  "item.minecraft.firework_rocket.flight": "Очу дәвамлылыгы:",
  "item.minecraft.firework_rocket.multiple_stars": "×%s %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Фейерверк йолдызы",
  "item.minecraft.firework_star.black": "Кара",
  "item.minecraft.firework_star.blue": "Зәңгәр",
  "item.minecraft.firework_star.brown": "Көрән",
  "item.minecraft.firework_star.custom_color": "Көйләнелгән",
  "item.minecraft.firework_star.cyan": "Фирәзә",
  "item.minecraft.firework_star.fade_to": "Сүнү төсе:",
  "item.minecraft.firework_star.flicker": "Җемелдәү",
  "item.minecraft.firework_star.gray": "Соры",
  "item.minecraft.firework_star.green": "Яшел",
  "item.minecraft.firework_star.light_blue": "Зәңгәрсу",
  "item.minecraft.firework_star.light_gray": "Соргылт",
  "item.minecraft.firework_star.lime": "Яшькелт",
  "item.minecraft.firework_star.magenta": "Куе кызыл",
  "item.minecraft.firework_star.orange": "Кызгылт сары",
  "item.minecraft.firework_star.pink": "Ал",
  "item.minecraft.firework_star.purple": "Шәмәхә",
  "item.minecraft.firework_star.red": "Кызыл",
  "item.minecraft.firework_star.shape": "Билгесез форма",
  "item.minecraft.firework_star.shape.burst": "Чапылдау",
  "item.minecraft.firework_star.shape.creeper": "Криперсыман",
  "item.minecraft.firework_star.shape.large_ball": "Олы шар",
  "item.minecraft.firework_star.shape.small_ball": "Кече шар",
  "item.minecraft.firework_star.shape.star": "Йолдызсыман",
  "item.minecraft.firework_star.trail": "Эз",
  "item.minecraft.firework_star.white": "Ак",
  "item.minecraft.firework_star.yellow": "Сары",
  "item.minecraft.fishing_rod": "Кармак",
  "item.minecraft.flint": "Чакматаш",
  "item.minecraft.flint_and_steel": "Чакма",
  "item.minecraft.flow_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.flow_armor_trim_smithing_template.new": "«Агым» бизәге",
  "item.minecraft.flow_banner_pattern": "Байрак бизәге",
  "item.minecraft.flow_banner_pattern.desc": "Агым",
  "item.minecraft.flow_banner_pattern.new": "«Агым» байрак бизәге",
  "item.minecraft.flow_pottery_sherd": "«Агым» чүлмәк ватыгы",
  "item.minecraft.flower_banner_pattern": "Байрак бизәге",
  "item.minecraft.flower_banner_pattern.desc": "Чәчәк",
  "item.minecraft.flower_banner_pattern.new": "«Чәчәк» байрак бизәге",
  "item.minecraft.flower_pot": "Чәчәк чүлмәге",
  "item.minecraft.fox_spawn_egg": "Төлке чакыру йомыркасы",
  "item.minecraft.friend_pottery_shard": "«Дус» чүлмәк ватыгы",
  "item.minecraft.friend_pottery_sherd": "«Дус» чүлмәк ватыгы",
  "item.minecraft.frog_spawn_egg": "Бака чакыру йомыркасы",
  "item.minecraft.furnace_minecart": "Мичле арбачык",
  "item.minecraft.ghast_spawn_egg": "Гаст чакыру йомыркасы",
  "item.minecraft.ghast_tear": "Гаст яше",
  "item.minecraft.glass_bottle": "Пыяла шешә",
  "item.minecraft.glistering_melon_slice": "Ялтыравык карбыз телеме",
  "item.minecraft.globe_banner_pattern": "Байрак бизәге",
  "item.minecraft.globe_banner_pattern.desc": "Глобус",
  "item.minecraft.globe_banner_pattern.new": "«Глобус» байрак бизәге",
  "item.minecraft.glow_berries": "Нурлы җиләкләр",
  "item.minecraft.glow_ink_sac": "Нурлы кара капчыгы",
  "item.minecraft.glow_item_frame": "Нурлы кысачык",
  "item.minecraft.glow_squid_spawn_egg": "Нурлы сигезаяк чакыру йомыркасы",
  "item.minecraft.glowstone_dust": "Яктыташ тузаны",
  "item.minecraft.goat_horn": "Кәҗә мөгезе",
  "item.minecraft.goat_spawn_egg": "Кәҗә чакыру йомыркасы",
  "item.minecraft.gold_ingot": "Алтын коелма",
  "item.minecraft.gold_nugget": "Алтын кисәге",
  "item.minecraft.golden_apple": "Алтын алма",
  "item.minecraft.golden_axe": "Алтын балта",
  "item.minecraft.golden_boots": "Алтын итек",
  "item.minecraft.golden_carrot": "Алтын кишер",
  "item.minecraft.golden_chestplate": "Алтын күкрәкчә",
  "item.minecraft.golden_helmet": "Алтын башлык",
  "item.minecraft.golden_hoe": "Алтын китмән",
  "item.minecraft.golden_horse_armor": "Алтын ат көбәсе",
  "item.minecraft.golden_leggings": "Алтын ыштан",
  "item.minecraft.golden_nautilus_armor": "Алтын наутилус көбәсе",
  "item.minecraft.golden_pickaxe": "Алтын кәйлә",
  "item.minecraft.golden_shovel": "Алтын көрәк",
  "item.minecraft.golden_spear": "Алтын сөңге",
  "item.minecraft.golden_sword": "Алтын кылыч",
  "item.minecraft.gray_bundle": "Соры капчык",
  "item.minecraft.gray_dye": "Соры буяу",
  "item.minecraft.gray_harness": "Соры җигем",
  "item.minecraft.green_bundle": "Яшел капчык",
  "item.minecraft.green_dye": "Яшел буяу",
  "item.minecraft.green_harness": "Яшел җигем",
  "item.minecraft.guardian_spawn_egg": "Каравылчы чакыру йомыркасы",
  "item.minecraft.gunpowder": "Дары",
  "item.minecraft.guster_banner_pattern": "Байрак бизәге",
  "item.minecraft.guster_banner_pattern.desc": "Өермә",
  "item.minecraft.guster_banner_pattern.new": "«Өермә» байрак бизәге",
  "item.minecraft.guster_pottery_sherd": "«Өермә» чүлмәк ватыгы",
  "item.minecraft.happy_ghast_spawn_egg": "Бәхетле гаст чакыру йомыркасы",
  "item.minecraft.harness": "Җигем",
  "item.minecraft.heart_of_the_sea": "Диңгез йөрәге",
  "item.minecraft.heart_pottery_shard": "«Йөрәк» чүлмәк ватыгы",
  "item.minecraft.heart_pottery_sherd": "«Йөрәк» чүлмәк ватыгы",
  "item.minecraft.heartbreak_pottery_shard": "«Йөрәк вату» чүлмәк ватыгы",
  "item.minecraft.heartbreak_pottery_sherd": "«Йөрәк вату» чүлмәк ватыгы",
  "item.minecraft.hoglin_spawn_egg": "Хоглин чакыру йомыркасы",
  "item.minecraft.honey_bottle": "Бал шешәсе",
  "item.minecraft.honeycomb": "Корт кәрәзләре",
  "item.minecraft.hopper_minecart": "Бүрәнкәле арбачык",
  "item.minecraft.horse_spawn_egg": "Ат чакыру йомыркасы",
  "item.minecraft.host_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.host_armor_trim_smithing_template.new": "«Хуҗа» бизәге",
  "item.minecraft.howl_pottery_shard": "«Улау» чүлмәк ватыгы",
  "item.minecraft.howl_pottery_sherd": "«Улау» чүлмәк ватыгы",
  "item.minecraft.husk_spawn_egg": "Үлек чакыру йомыркасы",
  "item.minecraft.ink_sac": "Кара капчыгы",
  "item.minecraft.iron_axe": "Тимер балта",
  "item.minecraft.iron_boots": "Тимер итек",
  "item.minecraft.iron_chestplate": "Тимер күкрәкчә",
  "item.minecraft.iron_golem_spawn_egg": "Тимер голем чакыру йомыркасы",
  "item.minecraft.iron_helmet": "Тимер башлык",
  "item.minecraft.iron_hoe": "Тимер китмән",
  "item.minecraft.iron_horse_armor": "Тимер ат көбәсе",
  "item.minecraft.iron_ingot": "Тимер коелма",
  "item.minecraft.iron_leggings": "Тимер ыштан",
  "item.minecraft.iron_nautilus_armor": "Тимер наутилус көбәсе",
  "item.minecraft.iron_nugget": "Тимер кисәге",
  "item.minecraft.iron_pickaxe": "Тимер кәйлә",
  "item.minecraft.iron_shovel": "Тимер көрәк",
  "item.minecraft.iron_spear": "Тимер сөңге",
  "item.minecraft.iron_sword": "Тимер кылыч",
  "item.minecraft.item_frame": "Кысачык",
  "item.minecraft.jungle_boat": "Тропик агач көймә",
  "item.minecraft.jungle_chest_boat": "Сандыклы тропик агач көймә",
  "item.minecraft.knowledge_book": "Белем китабы",
  "item.minecraft.lapis_lazuli": "Лазурит",
  "item.minecraft.lava_bucket": "Лава чиләге",
  "item.minecraft.lead": "Бау",
  "item.minecraft.leather": "Тире",
  "item.minecraft.leather_boots": "Күн итек",
  "item.minecraft.leather_chestplate": "Күн көртә",
  "item.minecraft.leather_helmet": "Күн башлык",
  "item.minecraft.leather_horse_armor": "Күн ат көбәсе",
  "item.minecraft.leather_leggings": "Күн ыштан",
  "item.minecraft.light_blue_bundle": "Зәңгәрсу капчык",
  "item.minecraft.light_blue_dye": "Зәңгәрсу буяу",
  "item.minecraft.light_blue_harness": "Зәңгәрсу җигем",
  "item.minecraft.light_gray_bundle": "Соргылт капчык",
  "item.minecraft.light_gray_dye": "Соргылт буяу",
  "item.minecraft.light_gray_harness": "Соргылт җигем",
  "item.minecraft.lime_bundle": "Яшькелт капчык",
  "item.minecraft.lime_dye": "Яшькелт буяу",
  "item.minecraft.lime_harness": "Яшькелт җигем",
  "item.minecraft.lingering_potion": "Томанлы төнәтмә",
  "item.minecraft.lingering_potion.effect.awkward": "Тонык томанлы төнәтмә",
  "item.minecraft.lingering_potion.effect.empty": "Томанлы ясамый торган төнәтмә",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Томанлы утка чыдамлылык төнәтмәсе",
  "item.minecraft.lingering_potion.effect.harming": "Томанлы кинәт зыян төнәтмәсе",
  "item.minecraft.lingering_potion.effect.healing": "Томанлы терелтү төнәтмәсе",
  "item.minecraft.lingering_potion.effect.infested": "Томанлы йоктыру төнәтмәсе",
  "item.minecraft.lingering_potion.effect.invisibility": "Томанлы күренмәүчәнлек төнәтмәсе",
  "item.minecraft.lingering_potion.effect.leaping": "Томанлы сикерүчәнлек төнәтмәсе",
  "item.minecraft.lingering_potion.effect.levitation": "Томанлы левитация төнәтмәсе",
  "item.minecraft.lingering_potion.effect.luck": "Томанлы уңыш төнәтмәсе",
  "item.minecraft.lingering_potion.effect.mundane": "Гади томанлы төнәтмә",
  "item.minecraft.lingering_potion.effect.night_vision": "Томанлы төн күрү төнәтмәсе",
  "item.minecraft.lingering_potion.effect.oozing": "Томанлы лайлалылык төнәтмәсе ",
  "item.minecraft.lingering_potion.effect.poison": "Томанлы агулану төнәтмәсе",
  "item.minecraft.lingering_potion.effect.regeneration": "Томанлы регенерация төнәтмәсе",
  "item.minecraft.lingering_potion.effect.slow_falling": "Томанлы салмак егылу төнәтмәсе",
  "item.minecraft.lingering_potion.effect.slowness": "Томанлы акрынаю төнәтмәсе",
  "item.minecraft.lingering_potion.effect.strength": "Томанлы көч төнәтмәсе",
  "item.minecraft.lingering_potion.effect.swiftness": "Томанлы тизлек төнәтмәсе",
  "item.minecraft.lingering_potion.effect.thick": "Куе томанлы төнәтмә",
  "item.minecraft.lingering_potion.effect.turtle_master": "Томанлы ташбака көче төнәтмәсе",
  "item.minecraft.lingering_potion.effect.water": "Томанлы су шешәсе",
  "item.minecraft.lingering_potion.effect.water_breathing": "Томанлы су сулыш төнәтмәсе",
  "item.minecraft.lingering_potion.effect.weakness": "Томанлы көчсезлек төнәтмәсе",
  "item.minecraft.lingering_potion.effect.weaving": "Томанлы үрү төнәтмәсе ",
  "item.minecraft.lingering_potion.effect.wind_charged": "Томанлы җиллек төнәтмәсе",
  "item.minecraft.llama_spawn_egg": "Лама чакыру йомыркасы",
  "item.minecraft.lodestone_compass": "Магнитланган компас",
  "item.minecraft.mace": "Чукмар",
  "item.minecraft.magenta_bundle": "Куе кызыл капчык",
  "item.minecraft.magenta_dye": "Куе кызыл буяу",
  "item.minecraft.magenta_harness": "Куе кызыл җигем",
  "item.minecraft.magma_cream": "Магма куерыгы",
  "item.minecraft.magma_cube_spawn_egg": "Магма кубы чакыру йомыркасы",
  "item.minecraft.mangrove_boat": "Мангр көймә",
  "item.minecraft.mangrove_chest_boat": "Сандыклы мангр көймә",
  "item.minecraft.map": "Буш харита",
  "item.minecraft.melon_seeds": "Карбыз орлыклары",
  "item.minecraft.melon_slice": "Карбыз телеме",
  "item.minecraft.milk_bucket": "Сөт чиләге",
  "item.minecraft.minecart": "Арбачык",
  "item.minecraft.miner_pottery_shard": "«Шахтачы» чүлмәк ватыгы",
  "item.minecraft.miner_pottery_sherd": "«Шахтачы» чүлмәк ватыгы",
  "item.minecraft.mojang_banner_pattern": "Байрак бизәге",
  "item.minecraft.mojang_banner_pattern.desc": "Нидер",
  "item.minecraft.mojang_banner_pattern.new": "«Нәрсәдер» байрак бизәге",
  "item.minecraft.mooshroom_spawn_egg": "Мөөшрум чакыру йомыркасы",
  "item.minecraft.mourner_pottery_shard": "«Кайгыручы» чүлмәк ватыгы",
  "item.minecraft.mourner_pottery_sherd": "«Кайгыручы» чүлмәк ватыгы",
  "item.minecraft.mule_spawn_egg": "Качыр чакыру йомыркасы",
  "item.minecraft.mushroom_stew": "Гөмбә ашы",
  "item.minecraft.music_disc_11": "Пластинка",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "Пластинка",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "Пластинка",
  "item.minecraft.music_disc_5.desc": "Самуил Аберг — 5",
  "item.minecraft.music_disc_blocks": "Пластинка",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "Пластинка",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Пластинка",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Пластинка",
  "item.minecraft.music_disc_creator.desc": "Лина Рейн — Creator",
  "item.minecraft.music_disc_creator_music_box": "Пластинка",
  "item.minecraft.music_disc_creator_music_box.desc": "Лина Рейн — Creator (Music Box)",
  "item.minecraft.music_disc_far": "Пластинка",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "Пластинка",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Пластинка",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "Пластинка",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Пластинка",
  "item.minecraft.music_disc_otherside.desc": "Лина Рейн — otherside",
  "item.minecraft.music_disc_pigstep": "Пластинка",
  "item.minecraft.music_disc_pigstep.desc": "Лина Рейн - Pigstep",
  "item.minecraft.music_disc_precipice": "Пластинка",
  "item.minecraft.music_disc_precipice.desc": "Аарон Шероф — Precipice",
  "item.minecraft.music_disc_relic": "Пластинка",
  "item.minecraft.music_disc_relic.desc": "Аарон Шероф — Relic",
  "item.minecraft.music_disc_stal": "Пластинка",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "Пластинка",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "Пластинка",
  "item.minecraft.music_disc_tears.desc": "Әймос Родди — Tears",
  "item.minecraft.music_disc_wait": "Пластинка",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "Пластинка",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "Чи бәрән ите",
  "item.minecraft.name_tag": "Тамга",
  "item.minecraft.nautilus_shell": "Наутилус кабырчыгы",
  "item.minecraft.nautilus_spawn_egg": "Наутилус чакыру йомыркасы",
  "item.minecraft.nether_brick": "Незер кирпеч",
  "item.minecraft.nether_star": "Незер йолдызы",
  "item.minecraft.nether_wart": "Незер үскене",
  "item.minecraft.netherite_axe": "Незерит балта",
  "item.minecraft.netherite_boots": "Незерит итек",
  "item.minecraft.netherite_chestplate": "Незерит күкрәкчә",
  "item.minecraft.netherite_helmet": "Незерит башлык",
  "item.minecraft.netherite_hoe": "Незерит китмән",
  "item.minecraft.netherite_horse_armor": "Незерит ат көбәсе",
  "item.minecraft.netherite_ingot": "Незерит коелма",
  "item.minecraft.netherite_leggings": "Незерит ыштан",
  "item.minecraft.netherite_nautilus_armor": "Незерит наутилус көбәсе",
  "item.minecraft.netherite_pickaxe": "Незерит кәйлә",
  "item.minecraft.netherite_scrap": "Незерит ватыгы",
  "item.minecraft.netherite_shovel": "Незерит көрәк",
  "item.minecraft.netherite_spear": "Незерит сөңге",
  "item.minecraft.netherite_sword": "Незерит кылыч",
  "item.minecraft.netherite_upgrade_smithing_template": "Тимерче калыбы",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Незерит яңарту",
  "item.minecraft.oak_boat": "Имән көймә",
  "item.minecraft.oak_chest_boat": "Сандыклы имән көймә",
  "item.minecraft.ocelot_spawn_egg": "Оцелот чакыру йомыркасы",
  "item.minecraft.ominous_bottle": "Дәһшәтле шешә",
  "item.minecraft.ominous_trial_key": "Дәһшәтле сынау ачкычы",
  "item.minecraft.orange_bundle": "Кызгылт сары капчык",
  "item.minecraft.orange_dye": "Кызгылт сары буяу",
  "item.minecraft.orange_harness": "Кызгылт сары җигем",
  "item.minecraft.painting": "Рәсем",
  "item.minecraft.pale_oak_boat": "Тонык имән көймә",
  "item.minecraft.pale_oak_chest_boat": "Сандыклы тонык имән көймә",
  "item.minecraft.panda_spawn_egg": "Панда чакыру йомыркасы",
  "item.minecraft.paper": "Кәгазь",
  "item.minecraft.parched_spawn_egg": "Корыгас чакыру йомыркасы",
  "item.minecraft.parrot_spawn_egg": "Тутый кош чакыру йомыркасы",
  "item.minecraft.phantom_membrane": "Өрәк мембранасы",
  "item.minecraft.phantom_spawn_egg": "Өрәк чакыру йомыркасы",
  "item.minecraft.pig_spawn_egg": "Дуңгыз чакыру йомыркасы",
  "item.minecraft.piglin_banner_pattern": "Байрак бизәге",
  "item.minecraft.piglin_banner_pattern.desc": "Чырай",
  "item.minecraft.piglin_banner_pattern.new": "«Чырай» байрак бизәге",
  "item.minecraft.piglin_brute_spawn_egg": "Тупас пиглин чакыру йомыркасы",
  "item.minecraft.piglin_spawn_egg": "Пиглин чакыру йомыркасы",
  "item.minecraft.pillager_spawn_egg": "Юлбасар чакыру йомыркасы",
  "item.minecraft.pink_bundle": "Ал капчык",
  "item.minecraft.pink_dye": "Ал буяу",
  "item.minecraft.pink_harness": "Ал җигем",
  "item.minecraft.pitcher_plant": "Комганчы",
  "item.minecraft.pitcher_pod": "Комганчы кузагы",
  "item.minecraft.plenty_pottery_shard": "«Муллык» чүлмәк ватыгы",
  "item.minecraft.plenty_pottery_sherd": "«Муллык» чүлмәк ватыгы",
  "item.minecraft.poisonous_potato": "Агулы бәрәңге",
  "item.minecraft.polar_bear_spawn_egg": "Ак аю чакыру йомыркасы",
  "item.minecraft.popped_chorus_fruit": "Куырылган хорус җимеше",
  "item.minecraft.porkchop": "Чи дуңгыз ите",
  "item.minecraft.potato": "Бәрәңге",
  "item.minecraft.potion": "Төнәтмә",
  "item.minecraft.potion.effect.awkward": "Тонык төнәтмә",
  "item.minecraft.potion.effect.empty": "Ясамый торган төнәтмә",
  "item.minecraft.potion.effect.fire_resistance": "Утка чыдамлылык төнәтмәсе",
  "item.minecraft.potion.effect.harming": "Кинәт зыян төнәтмәсе",
  "item.minecraft.potion.effect.healing": "Терелтү төнәтмәсе",
  "item.minecraft.potion.effect.infested": "Йоктыру төнәтмәсе",
  "item.minecraft.potion.effect.invisibility": "Күренмәүчәнлек төнәтмәсе",
  "item.minecraft.potion.effect.leaping": "Сикерүчәнлек төнәтмәсе",
  "item.minecraft.potion.effect.levitation": "Левитация төнәтмәсе",
  "item.minecraft.potion.effect.luck": "Уңыш төнәтмәсе",
  "item.minecraft.potion.effect.mundane": "Гади төнәтмә",
  "item.minecraft.potion.effect.night_vision": "Төн күрү төнәтмәсе",
  "item.minecraft.potion.effect.oozing": "Лайлалылык төнәтмәсе",
  "item.minecraft.potion.effect.poison": "Агулану төнәтмәсе",
  "item.minecraft.potion.effect.regeneration": "Регенерация төнәтмәсе",
  "item.minecraft.potion.effect.slow_falling": "Салмак егылу төнәтмәсе",
  "item.minecraft.potion.effect.slowness": "Акрынаю төнәтмәсе",
  "item.minecraft.potion.effect.strength": "Көч төнәтмәсе",
  "item.minecraft.potion.effect.swiftness": "Тизлек төнәтмәсе",
  "item.minecraft.potion.effect.thick": "Куе төнәтмә",
  "item.minecraft.potion.effect.turtle_master": "Ташбака көче төнәтмәсе",
  "item.minecraft.potion.effect.water": "Су шешәсе",
  "item.minecraft.potion.effect.water_breathing": "Су сулыш төнәтмәсе",
  "item.minecraft.potion.effect.weakness": "Көчсезлек төнәтмәсе",
  "item.minecraft.potion.effect.weaving": "Үрү төнәтмәсе",
  "item.minecraft.potion.effect.wind_charged": "Җиллек төнәтмәсе ",
  "item.minecraft.pottery_shard_archer": "«Җәяче» чүлмәк ватыгы",
  "item.minecraft.pottery_shard_arms_up": "«Өскә күтәрелгән куллар» чүлмәк ватыгы",
  "item.minecraft.pottery_shard_prize": "«Бүләк» чүлмәк ватыгы",
  "item.minecraft.pottery_shard_skull": "«Баш сөяге» чүлмәк ватыгы",
  "item.minecraft.powder_snow_bucket": "Көпшәк кар чиләге",
  "item.minecraft.prismarine_crystals": "Призмарин кристаллы",
  "item.minecraft.prismarine_shard": "Призмарин ватыгы",
  "item.minecraft.prize_pottery_shard": "«Бүләк» чүлмәк ватыгы",
  "item.minecraft.prize_pottery_sherd": "«Бүләк» чүлмәк ватыгы",
  "item.minecraft.pufferfish": "Энәкорсак",
  "item.minecraft.pufferfish_bucket": "Энәкорсак чиләге",
  "item.minecraft.pufferfish_spawn_egg": "Энәкорсак чакыру йомыркасы",
  "item.minecraft.pumpkin_pie": "Кабак бәлеше",
  "item.minecraft.pumpkin_seeds": "Кабак орлыклары",
  "item.minecraft.purple_bundle": "Шәмәхә капчык",
  "item.minecraft.purple_dye": "Шәмәхә буяу",
  "item.minecraft.purple_harness": "Шәмәхә җигем",
  "item.minecraft.quartz": "Незер-кварц",
  "item.minecraft.rabbit": "Чи куян ите",
  "item.minecraft.rabbit_foot": "Куян тәпие",
  "item.minecraft.rabbit_hide": "Куян тиресе",
  "item.minecraft.rabbit_spawn_egg": "Куян чакыру йомыркасы",
  "item.minecraft.rabbit_stew": "Куян ашы",
  "item.minecraft.raiser_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "«Җыючы» бизәге",
  "item.minecraft.ravager_spawn_egg": "Бөлдерүче чакыру йомыркасы",
  "item.minecraft.raw_copper": "Эшкәртелмәгән бакыр",
  "item.minecraft.raw_gold": "Эшкәртелмәгән алтын",
  "item.minecraft.raw_iron": "Эшкәртелмәгән тимер",
  "item.minecraft.recovery_compass": "Кайтаручы компас",
  "item.minecraft.red_bundle": "Кызыл капчык",
  "item.minecraft.red_dye": "Кызыл буяу",
  "item.minecraft.red_harness": "Кызыл җигем",
  "item.minecraft.redstone": "Редстоун тузаны",
  "item.minecraft.resin_brick": "Сагыз кирпеч",
  "item.minecraft.resin_clump": "Сагыз төере",
  "item.minecraft.rib_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.rib_armor_trim_smithing_template.new": "«Кабырга» бизәге",
  "item.minecraft.rotten_flesh": "Черек тән",
  "item.minecraft.saddle": "Утыргыч",
  "item.minecraft.salmon": "Чи сөләйман",
  "item.minecraft.salmon_bucket": "Сөләйман чиләге",
  "item.minecraft.salmon_spawn_egg": "Сөләйман чакыру йомыркасы",
  "item.minecraft.scrape_pottery_sherd": "«Шыгырдау» чүлмәк ватыгы",
  "item.minecraft.scute": "Калканчык",
  "item.minecraft.sentry_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "«Каравылчы» бизәге",
  "item.minecraft.shaper_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "«Рәссам» бизәге",
  "item.minecraft.sheaf_pottery_shard": "«Бәйләм» чүлмәк ватыгы",
  "item.minecraft.sheaf_pottery_sherd": "«Бәйләм» чүлмәк ватыгы",
  "item.minecraft.shears": "Кайчы",
  "item.minecraft.sheep_spawn_egg": "Сарык чакыру йомыркасы",
  "item.minecraft.shelter_pottery_shard": "«Ышык урын» чүлмәк ватыгы",
  "item.minecraft.shelter_pottery_sherd": "«Ышык урын» чүлмәк ватыгы",
  "item.minecraft.shield": "Калкан",
  "item.minecraft.shield.black": "Кара калкан",
  "item.minecraft.shield.blue": "Зәңгәр калкан",
  "item.minecraft.shield.brown": "Көрән калкан",
  "item.minecraft.shield.cyan": "Фирәзә калкан",
  "item.minecraft.shield.gray": "Соры калкан",
  "item.minecraft.shield.green": "Яшел калкан",
  "item.minecraft.shield.light_blue": "Зәңгәрсу калкан",
  "item.minecraft.shield.light_gray": "Соргылт калкан",
  "item.minecraft.shield.lime": "Яшькелт калкан",
  "item.minecraft.shield.magenta": "Куе кызыл калкан",
  "item.minecraft.shield.orange": "Кызгылт сары калкан",
  "item.minecraft.shield.pink": "Ал калкан",
  "item.minecraft.shield.purple": "Шәмәхә калкан",
  "item.minecraft.shield.red": "Кызыл калкан",
  "item.minecraft.shield.white": "Ак калкан",
  "item.minecraft.shield.yellow": "Сары калкан",
  "item.minecraft.shulker_shell": "Шалкер кабырчыгы",
  "item.minecraft.shulker_spawn_egg": "Шалкер чакыру йомыркасы",
  "item.minecraft.sign": "Билге",
  "item.minecraft.silence_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.silence_armor_trim_smithing_template.new": "«Тынлык» бизәге",
  "item.minecraft.silverfish_spawn_egg": "Коңгыз чакыру йомыркасы",
  "item.minecraft.skeleton_horse_spawn_egg": "Скелет ат чакыру йомыркасы",
  "item.minecraft.skeleton_spawn_egg": "Скелет чакыру йомыркасы",
  "item.minecraft.skull_banner_pattern": "Байрак бизәге",
  "item.minecraft.skull_banner_pattern.desc": "Баш сөяге",
  "item.minecraft.skull_banner_pattern.new": "«Баш сөяге» байрак бизәге",
  "item.minecraft.skull_pottery_shard": "«Баш сөяге» чүлмәк ватыгы",
  "item.minecraft.skull_pottery_sherd": "«Баш сөяге» чүлмәк ватыгы",
  "item.minecraft.slime_ball": "Лайла куерыгы",
  "item.minecraft.slime_spawn_egg": "Лайлач чакыру йомыркасы",
  "item.minecraft.smithing_template": "Тимерче калыбы",
  "item.minecraft.smithing_template.applies_to": "Предметларның күрсәтелгән төрләренә кулланыла:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Коелманы яки кристаллны куегыз",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Көбә",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Көбә өлешен монда куегыз",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Коелмалар һәм кристаллар",
  "item.minecraft.smithing_template.ingredients": "Материаллар:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Незерит коелманы куегыз",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Алмаз кирәк-яраклар",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Алмаз коралларны яки көбә өлешен монда куегыз",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Незерит коелма",
  "item.minecraft.smithing_template.upgrade": "Яңарту: ",
  "item.minecraft.sniffer_spawn_egg": "Иснәүче чакыру йомыркасы",
  "item.minecraft.snort_pottery_shard": "«Иснәү» чүлмәк ватыгы",
  "item.minecraft.snort_pottery_sherd": "«Иснәү» чүлмәк ватыгы",
  "item.minecraft.snout_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.snout_armor_trim_smithing_template.new": "«Чырай» бизәге",
  "item.minecraft.snow_golem_spawn_egg": "Кар бабай чакыру йомыркасы",
  "item.minecraft.snowball": "Йомарланган кар",
  "item.minecraft.spectral_arrow": "Спектраль ук",
  "item.minecraft.spider_eye": "Үрмәкүч күзе",
  "item.minecraft.spider_spawn_egg": "Үрмәкүч чакыру йомыркасы",
  "item.minecraft.spire_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.spire_armor_trim_smithing_template.new": "«Оч» бизәге",
  "item.minecraft.splash_potion": "Шартлаулы төнәтмә",
  "item.minecraft.splash_potion.effect.awkward": "Тонык шартлаулы төнәтмә",
  "item.minecraft.splash_potion.effect.empty": "Шартлаулы ясамый торган төнәтмә",
  "item.minecraft.splash_potion.effect.fire_resistance": "Шартлаулы утка чыдамлылык төнәтмәсе",
  "item.minecraft.splash_potion.effect.harming": "Шартлаулы кинәт зыян төнәтмәсе",
  "item.minecraft.splash_potion.effect.healing": "Шартлаулы терелтү төнәтмәсе",
  "item.minecraft.splash_potion.effect.infested": "Шартлаулы йоктыру төнәтмәсе",
  "item.minecraft.splash_potion.effect.invisibility": "Шартлаулы күренмәүчәнлек төнәтмәсе",
  "item.minecraft.splash_potion.effect.leaping": "Шартлаулы сикерүчәнлек төнәтмәсе",
  "item.minecraft.splash_potion.effect.levitation": "Шартлаулы левитация төнәтмәсе",
  "item.minecraft.splash_potion.effect.luck": "Шартлаулы уңыш төнәтмәсе",
  "item.minecraft.splash_potion.effect.mundane": "Гади шартлаулы төнәтмә",
  "item.minecraft.splash_potion.effect.night_vision": "Шартлаулы төн күрү төнәтмәсе",
  "item.minecraft.splash_potion.effect.oozing": "Шартлаулы лайлалылык төнәтмәсе ",
  "item.minecraft.splash_potion.effect.poison": "Шартлаулы агулану төнәтмәсе",
  "item.minecraft.splash_potion.effect.regeneration": "Шартлаулы регенерация төнәтмәсе",
  "item.minecraft.splash_potion.effect.slow_falling": "Шартлаулы салмак егылу төнәтмәсе",
  "item.minecraft.splash_potion.effect.slowness": "Шартлаулы акрынаю төнәтмәсе",
  "item.minecraft.splash_potion.effect.strength": "Шартлаулы көч төнәтмәсе",
  "item.minecraft.splash_potion.effect.swiftness": "Шартлаулы тизлек төнәтмәсе",
  "item.minecraft.splash_potion.effect.thick": "Гади шартлаулы төнәтмә",
  "item.minecraft.splash_potion.effect.turtle_master": "Шартлаулы ташбака көче төнәтмәсе",
  "item.minecraft.splash_potion.effect.water": "Шартлаулы су шешәсе",
  "item.minecraft.splash_potion.effect.water_breathing": "Шартлаулы су сулыш төнәтмәсе",
  "item.minecraft.splash_potion.effect.weakness": "Шартлаулы көчсезлек төнәтмәсе",
  "item.minecraft.splash_potion.effect.weaving": "Шартлаулы үрү төнәтмәсе",
  "item.minecraft.splash_potion.effect.wind_charged": "Шартлаулы җиллек төнәтмәсе",
  "item.minecraft.spruce_boat": "Чыршы көймә",
  "item.minecraft.spruce_chest_boat": "Сандыклы чыршы көймә",
  "item.minecraft.spyglass": "Күзәтү торбасы",
  "item.minecraft.squid_spawn_egg": "Сигезаяк чакыру йомыркасы",
  "item.minecraft.stick": "Таяк",
  "item.minecraft.stone_axe": "Таш балта",
  "item.minecraft.stone_hoe": "Таш китмән",
  "item.minecraft.stone_pickaxe": "Таш кәйлә",
  "item.minecraft.stone_shovel": "Таш көрәк",
  "item.minecraft.stone_spear": "Таш сөңге",
  "item.minecraft.stone_sword": "Таш кылыч",
  "item.minecraft.stray_spawn_egg": "Сукбай чакыру йомыркасы",
  "item.minecraft.strider_spawn_egg": "Страйдер чакыру йомыркасы",
  "item.minecraft.string": "Җеп",
  "item.minecraft.sugar": "Шикәр",
  "item.minecraft.suspicious_stew": "Серле аш",
  "item.minecraft.sweet_berries": "Баллы җиләкләр",
  "item.minecraft.tadpole_bucket": "Чукмарбаш чиләге",
  "item.minecraft.tadpole_spawn_egg": "Чукмарбаш чакыру йомыркасы",
  "item.minecraft.tide_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.tide_armor_trim_smithing_template.new": "«Күтәрелү» бизәге",
  "item.minecraft.tipped_arrow": "Чумдырган ук",
  "item.minecraft.tipped_arrow.effect.awkward": "Чумдырган ук",
  "item.minecraft.tipped_arrow.effect.empty": "Ясамый торган төнәтмәгә чумдырган ук",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Утка чыдамлылык угы",
  "item.minecraft.tipped_arrow.effect.harming": "Кинәт зыян угы",
  "item.minecraft.tipped_arrow.effect.healing": "Шифа угы",
  "item.minecraft.tipped_arrow.effect.infested": "Йоктыру угы",
  "item.minecraft.tipped_arrow.effect.invisibility": "Күренмәүчәнлек угы",
  "item.minecraft.tipped_arrow.effect.leaping": "Сикерүчәнлек угы",
  "item.minecraft.tipped_arrow.effect.levitation": "Левитация угы",
  "item.minecraft.tipped_arrow.effect.luck": "Уңыш угы",
  "item.minecraft.tipped_arrow.effect.mundane": "Чумдырган ук",
  "item.minecraft.tipped_arrow.effect.night_vision": "Төн күрү угы",
  "item.minecraft.tipped_arrow.effect.oozing": "Лайлалылык угы",
  "item.minecraft.tipped_arrow.effect.poison": "Агулану угы",
  "item.minecraft.tipped_arrow.effect.regeneration": "Регенерация угы",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Салмак егылу угы",
  "item.minecraft.tipped_arrow.effect.slowness": "Акрынаю угы",
  "item.minecraft.tipped_arrow.effect.strength": "Көч угы",
  "item.minecraft.tipped_arrow.effect.swiftness": "Тизлек угы",
  "item.minecraft.tipped_arrow.effect.thick": "Чумдырган ук",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Ташбака көче угы",
  "item.minecraft.tipped_arrow.effect.water": "Шартлаулы ук",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Су сулыш угы",
  "item.minecraft.tipped_arrow.effect.weakness": "Көчсезлек угы",
  "item.minecraft.tipped_arrow.effect.weaving": "Үрү угы",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Җиллек угы",
  "item.minecraft.tnt_minecart": "Динамитлы арбачык",
  "item.minecraft.torchflower_seeds": "Факелгөл орлыклары",
  "item.minecraft.totem_of_undying": "Үлемсезлек тотемы",
  "item.minecraft.trader_llama_spawn_egg": "Сәүдәгәр ламасы чакыру йомыркасы",
  "item.minecraft.trial_key": "Сынау ачкычы",
  "item.minecraft.trident": "Өчтырнак",
  "item.minecraft.tropical_fish": "Тропик балыгы",
  "item.minecraft.tropical_fish_bucket": "Тропик балык чиләге",
  "item.minecraft.tropical_fish_spawn_egg": "Тропик балык чакыру йомыркасы",
  "item.minecraft.turtle_helmet": "Ташбака кабырчыгы",
  "item.minecraft.turtle_scute": "Ташбака калканчыгы",
  "item.minecraft.turtle_spawn_egg": "Ташбака чакыру йомыркасы",
  "item.minecraft.vex_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.vex_armor_trim_smithing_template.new": "«Газаплаучы» бизәге",
  "item.minecraft.vex_spawn_egg": "Газаплаучы чакыру йомыркасы",
  "item.minecraft.villager_spawn_egg": "Крестьян чакыру йомыркасы",
  "item.minecraft.vindicator_spawn_egg": "Кыерсытучы чакыру йомыркасы",
  "item.minecraft.wandering_trader_spawn_egg": "Гизүче сәүдәгәр чакыру йомыркасы",
  "item.minecraft.ward_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.ward_armor_trim_smithing_template.new": "«Сакчы» бизәге",
  "item.minecraft.warden_spawn_egg": "Сакчы чакыру йомыркасы",
  "item.minecraft.warped_fungus_on_a_stick": "Гаҗәп гөмбәле кармак",
  "item.minecraft.water_bucket": "Су чиләге",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "«Эзләүче» бизәге",
  "item.minecraft.wheat": "Бодай",
  "item.minecraft.wheat_seeds": "Бодай орлыклары",
  "item.minecraft.white_bundle": "Ак капчык",
  "item.minecraft.white_dye": "Ак буяу",
  "item.minecraft.white_harness": "Ак җигем",
  "item.minecraft.wild_armor_trim_smithing_template": "Тимерче калыбы",
  "item.minecraft.wild_armor_trim_smithing_template.new": "«Куаклык» бизәге",
  "item.minecraft.wind_charge": "Җил корылмасы",
  "item.minecraft.witch_spawn_egg": "Убырлы чакыру йомыркасы",
  "item.minecraft.wither_skeleton_spawn_egg": "Визер-скелет чакыру йомыркасы",
  "item.minecraft.wither_spawn_egg": "Визер чакыру йомыркасы",
  "item.minecraft.wolf_armor": "Бүре көбәсе",
  "item.minecraft.wolf_spawn_egg": "Бүре чакыру йомыркасы",
  "item.minecraft.wooden_axe": "Агач балта",
  "item.minecraft.wooden_hoe": "Агач китмән",
  "item.minecraft.wooden_pickaxe": "Агач кәйлә",
  "item.minecraft.wooden_shovel": "Агач көрәк",
  "item.minecraft.wooden_spear": "Агач сөңге",
  "item.minecraft.wooden_sword": "Агач кылыч",
  "item.minecraft.writable_book": "Китап вә каләм",
  "item.minecraft.written_book": "Төгәлләнгән китап",
  "item.minecraft.yellow_bundle": "Сары капчык",
  "item.minecraft.yellow_dye": "Сары буяу",
  "item.minecraft.yellow_harness": "Сары җигем",
  "item.minecraft.zoglin_spawn_egg": "Зоглин чакыру йомыркасы",
  "item.minecraft.zombie_horse_spawn_egg": "Зомби-ат чакыру йомыркасы",
  "item.minecraft.zombie_nautilus_spawn_egg": "Зомби-наутилус чакыру йомыркасы",
  "item.minecraft.zombie_spawn_egg": "Зомби чакыру йомыркасы",
  "item.minecraft.zombie_villager_spawn_egg": "Зомби-крестьян чакыру йомыркасы",
  "item.minecraft.zombified_piglin_spawn_egg": "Зомбиланган пиглин чакыру йомыркасы"
}
export const tt_ru = items; 
